<template>
  <div class="newsEdition container-fluid">
    <div class="newsEditionFirst">
      <b-row class="sections">
        <b-col sm="2" style="height: 100vh">
          <b-col style="margin-bottom: 45px">
            <img src="../assets/logo.png" />
          </b-col>
          <b-col class="section1Title">
            <b-row>
              <b-col style="text-align: left" sm="4">Fontes</b-col>
              <b-col class="createDiv" sm="8">
                <b-button class="createBtn createBtnFonte" @click="showData()"
                  >Atualizar SRC</b-button
                >
              </b-col>
            </b-row>
          </b-col>
          <b-col class="section1">
            <b-form-checkbox
              v-model="isFiltered"
              value="1"
              style="margin-bottom: 20px"
              unchecked-value="0"
              >Mostrar fontes com noticias por editar</b-form-checkbox
            >
            <b-col class="contentOfSection1">
              <b-row
                v-for="(source, index) in filteredSourceArray"
                :key="source.c_id"
              >
                <b-col sm="10">
                  <p
                    @click="clickedEvent(index, source.c_u_ReferenceSource)"
                    class="section1Name"
                  >
                    {{ source.c_u_ReferenceSource }}
                    <span
                      >[{{ newsForLength[source.c_id].totalOfNumber }}]</span
                    >
                  </p>
                </b-col>
                <b-row sm="1" v-if="source.c_u_Status == 1">
                  <fa
                    :icon="['fas', 'clipboard-check']"
                    size="1x"
                    style="color: #d1d6a3; margin-right: 4px"
                    v-if="newsForLength[source.c_id].isTrue"
                  />
                  <fa
                    v-if="source.c_u_PublishType == 2"
                    :icon="['fab', 'adn']"
                    style="color: rgb(24, 65, 77); margin-right: 4px"
                    size="1x"
                  />
                  <fa
                    :icon="['fas', 'check-circle']"
                    size="1x"
                    style="color: green"
                  />
                </b-row>
                <b-col sm="1" v-if="source.c_u_Status == -1">
                  <fa
                    :icon="['fas', 'times-circle']"
                    size="1x"
                    style="color: red"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-col>
        </b-col>
        <b-col sm="10" style="height: 100%" class="everySection">
          <b-row class="navBar">
            <b-col
              class="text-center navbar1"
              @click="$router.push({ name: 'Home' })"
            >
              <a>Dashboard</a>
            </b-col>
            <b-col
              class="navbar2"
              @click="$router.push({ name: 'NewsEdition' })"
            >
              <a>Noticias</a>
            </b-col>
            <b-col class="navbar3">
              <div class="dropdown">
                <span>Configurações</span>
                <div class="dropdown-content">
                  <a @click="$router.push({ name: 'SourceMain' })">Fonte</a>
                  <a @click="$router.push({ name: 'ThemeWords' })"
                    >Theme Words</a
                  >
                </div>
              </div>
            </b-col>
            <b-col
              class="navbar4"
              @click="$router.push({ name: 'OperationLog' })"
            >
              <a>Relatorio Logs/Erros</a>
            </b-col>
          </b-row>
          <b-row
            class="sectionsFilters"
            id="filtersHeightSize"
            v-resize
            @resize="onResize"
          >
            <b-col>
              <b-row>
                <div class="filters">
                  <p>Filtros</p>
                </div>
                <b-col style="padding: 0px 2px">
                  <b-row>
                    <b-col sm="12">
                      <span class="filtersTitle">Fonte</span>
                    </b-col>
                    <b-col>
                      <v-select
                        multiple
                        v-model="selectedFilterSource"
                        :options="optionsFilterSource"
                        label="item"
                        :reduce="(item) => item.code"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="padding: 0px 2px">
                  <b-row>
                    <b-col sm="12">
                      <span class="filtersTitle">Tipo</span>
                    </b-col>
                    <b-col>
                      <v-select
                        v-model="selectedFilterType"
                        :options="optionsTypeNews"
                        label="type"
                        :reduce="(type) => type.code"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="padding: 0px 2px">
                  <b-row>
                    <b-col sm="12">
                      <span class="filtersTitle">Tematica</span>
                    </b-col>
                    <b-col>
                      <v-select
                        v-model="selectedFilterTheme"
                        :options="optionsFilterTheme"
                        id="themeDropDown"
                        label="theme"
                        :reduce="(theme) => theme.code"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="padding: 0px 2px">
                  <b-col style="padding: 0px 2px">
                    <span class="filtersTitle">Data de inicio</span>
                    <b-form-input
                      v-model="filtersDates.startDate"
                      type="date"
                      size="sm"
                      style="height: 34.65px"
                    ></b-form-input>
                  </b-col>
                </b-col>
                <b-col style="padding: 0px 2px">
                  <b-col style="padding: 0px 2px">
                    <span class="filtersTitle">Data de fim</span>
                    <b-form-input
                      v-model="filtersDates.endDate"
                      type="date"
                      size="sm"
                      style="height: 34.65px"
                    ></b-form-input>
                  </b-col>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col sm="12" style="padding: 0px 2px">
                      <span class="filtersTitle">Estado</span>
                    </b-col>
                    <b-col style="padding: 0px 2px">
                      <v-select
                        v-model="selectedFilterStatus"
                        :options="optionsStatus"
                        label="status"
                        :reduce="(status) => status.code"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="padding: 0px 2px">
                  <b-row>
                    <b-col sm="12">
                      <span class="filtersTitle">Utilizador</span>
                    </b-col>
                    <b-col>
                      <v-select
                        v-model="selectedFilterUsers"
                        :options="filtersUsers"
                        id="usersDropDown"
                        label="name"
                        :reduce="(name) => name.id"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="padding: 0px 2px" class="textBtn">
                  <b-col style="padding: 0px 2px">
                    <span class="filtersTitle">Texto</span>
                    <b-form-input
                      v-model="filteredText"
                      size="sm"
                      style="width: 140px; height: 34.65px"
                    ></b-form-input>
                  </b-col>
                </b-col>
                <b-col sm="1" class="btnClear">
                  <b-button
                    class="btnFilters"
                    @click="clearFilters()"
                    style="background-color: white; color: black"
                    >Limpar</b-button
                  >
                </b-col>
                <b-col
                  sm="1"
                  style="margin-right: 25px; padding: 0px"
                  class="btnSearch"
                >
                  <b-button
                    class="btnFilters"
                    @click="filterData()"
                    style="background-color: #428bac"
                    >Pesquisar</b-button
                  >
                </b-col>
              </b-row>
              <b-row class="ifLowWidth" style="display: none">
                <b-col
                  class="d-flex justify-content-end"
                  style="margin-right: 10px"
                >
                  <b-button
                    class="btnFilters"
                    @click="clearFilters()"
                    style="background-color: white; color: black"
                    >Limpar</b-button
                  >
                </b-col>
                <b-col
                  sm="1"
                  style="margin-right: 25px; padding: 0px"
                  class="d-flex justify-content-end"
                >
                  <b-button
                    class="btnFilters"
                    @click="filterData()"
                    style="background-color: #428bac"
                    >Pesquisar</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- NEWS CREATION -->
          <b-col class="newsCreationContainer">
            <b-row style="height: 100%; width: 100%">
              <b-col sm="9" class="section5Div">
                <b-col style="display: inline">
                  <b-col class="section1Title">
                    <p>Criação de Noticia</p>
                  </b-col>
                  <b-col class="section5">
                    <b-col>
                      <b-col>
                        <h6 class="section3Title">Fonte</h6>
                        <v-select
                          v-model="sourceOfCreatedNew"
                          :options="optionsSourceForCreate"
                          label="item"
                          :reduce="(item) => item.code"
                          style="background-color: white"
                        >
                          <span slot="no-options"
                            >Não foram obtidos resultados</span
                          >
                        </v-select>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Tipo de Noticia</h6>
                        <v-select
                          v-model="createdNew.c_u_NewsOriginType"
                          :options="optionsNewsOriginType"
                          label="item"
                          :reduce="(item) => item.code"
                          style="background-color: white"
                        >
                          <span slot="no-options"
                            >Não foram obtidos resultados</span
                          >
                        </v-select>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Programa</h6>
                        <b-form-input
                          v-model="createdNew.c_u_News_MMS_ProgramName"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Titulo</h6>
                        <b-form-textarea
                          id="textarea"
                          v-model="createdNew.c_u_Title"
                          rows="3"
                          max-rows="6"
                        ></b-form-textarea>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Data/Hora</h6>
                        <b-row>
                          <b-col sm="6">
                            <b-form-input type="date" v-model="_newsDate"></b-form-input>
                          </b-col>
                          <b-col sm="6">
                            <b-form-input type="time" v-model="_newsTime"></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Resumo</h6>
                        <editor id="taNewSummary"
                          apiKey="l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl"
                          licenseKey="gpl"
                          v-model="createdNew.c_u_Summary"
                          :init="{
                            height: 250,
                            menubar: true,
                            entity_encoding: 'raw',
                            toolbar1:
                              'styleselect | bold italic | alignleft aligncenter alignright alignjustify',
                          }"
                        />
                      </b-col>
                      <b-col v-if="!isNotCreatedNew">
                        <h6 class="section3Title">Imagem</h6>
                        <b-col class="section3Image">
                          <b-row class="section3ImageMargin">
                            <b-col sm="6">
                              <b-col>
                                <img
                                  id="output"
                                  style="width: 200px; height: 200px"
                                />
                                <b-row>
                                  <b-col class="imageBtnStyle">
                                    <fa
                                      class="label"
                                      :icon="['fa', 'search-plus']"
                                      size="lg"
                                      style="cursor: pointer"
                                      @click="openEnLargeImg"
                                    />
                                  </b-col>
                                  <b-col class="imageBtnStyle">
                                    <fa
                                      class="label"
                                      style="cursor: pointer"
                                      :icon="['fa', 'times']"
                                      size="lg"
                                      @click="deleteImg"
                                    />
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                            <b-col>
                              <b-col class="uploadBtn">
                                <fa
                                  class="label"
                                  :icon="['fas', 'plus']"
                                  size="lg"
                                />
                                <input
                                  id="files"
                                  name="files"
                                  type="file"
                                  @change="uploadFiles('files', newsArray.c_id)"
                                />
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                      <!-- The Modal -->
                      <div id="myModal" class="modal">
                        <span class="close">&times;</span>
                        <img class="modal-content" id="img01" />
                        <div id="caption"></div>
                      </div>
                      <b-col>
                        <h6 class="section3Title">Media <small>(mp3, mp4)</small></h6>
                        <b-col class="section3Image">
                          <b-row class="section3ImageMargin">
                            <b-col sm="6" id="fileVideoAudio1">
                              <input
                                id="filesMedia1"
                                name="filesMedia1"
                                type="file"
                                accept=".mp3,.mp4"
                                @change="uploadFilesMedia('filesMedia1', newsArray.c_id)"
                                @click="$event.target.value=''"
                              />
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                      <b-col>
                        <h6 class="section3Title">Conteúdo</h6>
                        <editor id="taNewContent"
                          apiKey="l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl"
                          licenseKey="gpl"
                          v-model="contentOfCreatedNew"
                          :init="this.configTinyMce"
                        />
                        <b-button
                          style="
                            background-color: rgb(44, 99, 112);
                            margin-top: 5px;
                          "
                          @click="findThematics()"
                          >Reconhecer temáticas no texto</b-button
                        >
                        <div id="imageUpload" class="hidden"></div>
                      </b-col>
                      <b-col v-if="!isNotCreatedNew">
                        <h6 class="section3Title">Temáticas</h6>
                        <b-col @drop="drop" @dragover="allowDrop" sm="12">
                          <b-row
                            v-if="selectedThematics.length == 0"
                            class="d-flex justify-content-center"
                          >
                            <p style="font-weight: bold">
                              Não existem temáticas associadas
                            </p>
                          </b-row>
                          <b-row v-if="selectedThematics.length > 0" class="thematics">
                            <p
                              class="thematic"
                              v-for="(item, index) in selectedThematics"
                              :key="index"
                              :data-id="`${item.id}`"
                            >
                              {{ item.wordName }}
                              <span style="text-align: right">
                                <fa
                                  class="thematicRemove"
                                  :icon="['fas', 'times']"
                                  size="sm"
                                  style="color: black; cursor: pointer"
                                  @click="deleteThematic(index, newsArray.c_id)"
                                />
                              </span>
                            </p>
                          </b-row>
                        </b-col>
                      </b-col>
                      <b-row>
                        <b-col sm="4">
                          <h6 class="section3Title">FAV</h6>
                          <v-select
                            v-model="createdNew.c_u_NewsidxFav"
                            style="background-color: white"
                            :options="optionsFavView"
                            append-to-body
                            :calculate-position="withPopper"
                            label="id"
                            :reduce="(fav) => fav.id"
                          >
                            <span slot="no-options"
                              >Não foram obtidos resultados</span
                            >
                          </v-select>
                        </b-col>
                        <b-col sm="8">
                          <h6 class="section3Title">AVE</h6>
                          <v-select
                            v-model="createdNew.c_u_NewsAVE"
                            id="AVEdropDown"
                            append-to-body
                            :calculate-position="withPopper"
                            :options="optionsAve"
                            label="newAve"
                            :reduce="(newAve) => newAve.id"
                          >
                            <span slot="no-options"
                              >Não foram obtidos resultados</span
                            >
                          </v-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <h6 class="section3Title">Página</h6>
                          <b-input 
                            type="number"
                            min="0"
                            v-model="createdNew.c_u_NewsPageNumber"
                          ></b-input>
                        </b-col>
                        <b-col sm="8">
                          <h6 class="section3Title">Jornalista</h6>
                          <v-select
                            taggable
                            label="name"
                            append-to-body
                            :calculate-position="withPopper"
                            style="background-color: white"
                            id="journalistDropDown"
                            v-model="createdNew.c_r_Journalist"
                            :options="optionsJournalists"
                            :reduce="(journalist) => journalist.id ? journalist.id : journalist"
                            @input="(journalist) => createJournalist(journalist)"
                          >
                            <span slot="no-options"
                              >Não foram obtidos resultados</span
                            >
                          </v-select>
                        </b-col>
                      </b-row>
                      <b-row style="margin-top: 10px">
                        <b-col sm="1">
                          <b-form-checkbox
                            v-model="createdNew.c_u_isHighlighted"
                            value="true"
                            unchecked-value="false"
                            class="section3Title"
                            >Destaque</b-form-checkbox
                          >
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          class="d-flex justify-content-end"
                          style="margin-bottom: 20px"
                        >
                          <b-button
                            style="
                              margin-right: 5px;
                              background-color: rgb(66, 139, 172);
                            "
                            @click="rememberCreateObject(createdNew)"
                            >Memorizar</b-button
                          >
                          <b-button
                            style="
                              margin-left: 5px;
                              background-color: rgb(44, 99, 112);
                            "
                            @click="loadCreateObject()"
                            >Carregar</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                  <b-col class="section2Footer">
                    <b-row class="d-flex justify-content-end">
                      <b-col sm="3">
                        <b-button
                          style="background-color: rgb(162, 91, 113)"
                          @click="cancelCreationOfNew()"
                          >Cancelar</b-button
                        >
                      </b-col>
                      <b-col sm="3">
                        <b-button
                          style="background-color: rgb(99, 190, 200)"
                          @click="postCreateNew(createdNew)"
                          >Guardar</b-button
                        >
                      </b-col>
                      <b-col sm="3">
                        <b-button
                          style="background-color: rgb(160, 205, 99)"
                          @click="publishCreateNew(createdNew)"
                          >Publicar</b-button
                        >
                      </b-col>
                      <b-col sm="3">
                        <b-button
                          style="background-color: rgb(160, 205, 99)"
                          @click="copyCreateNew(createdNew)"
                          >Descarregar</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-col>
              <b-col class="section6Div" sm="3" style="padding: 0px" v-on:keyup="thematicKB($event)">
                <b-col style="display: inline; overflow: hidden">
                  <b-col class="section1Title">
                    <p>Tematicas</p>
                  </b-col>
                  <b-col>
                    <b-row style="margin-bottom: 20px">
                      <b-col sm="12" style="padding: 0px">
                        <span class="filtersTitle">Pesquisa</span>
                      </b-col>
                      <b-col style="padding: 0px">
                        <b-form-input v-model="thematicsSearch" autocomplete="off"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    class="section6Themes"
                    id="sectionThems"
                    v-if="!isNotCreatedNew"
                  >
                    <b-col
                      class="thematicStyle"
                      v-for="(item, index) in thematicItems"
                      :key="index"
                      :id="`drag${item.id}`"
                      :data-id="`${item.id}`"
                      draggable="false"
                      @dragstart="drag"
                      @click="drag(item)"
                      >{{ item.wordName }}</b-col
                    >
                  </b-col>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
          <!-- NEWS EDITION SECTION2 -->
          <b-row style="width: 100%; height: 100%">
            <b-col sm="5" class="section2Div">
              <b-col style="display: inline">
                <b-col class="section1Title">
                  <b-row>
                    <b-col style="text-align: left">Noticias</b-col>
                    <b-col class="createDiv">
                      <b-button class="createBtn" @click="refreshNews()"
                        >Atualizar</b-button
                      >
                      <b-button class="createBtn" @click="createNewsInfo()"
                        >Criar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  id="section2"
                  v-if="filteredsNews != []"
                  class="section2"
                  v-on:scroll.passive="handleScrolll"
                >
                  <!-- v-on:scroll.passive="handleScrolll" -->
                  <b-row style="margin-top: 5px">
                    <!-- <b-col v-if="filteredsNews.length > 0" class="d-flex justify-content-start">
                      <b-button
                        class="btnFilters"
                        @click="refreshNews()"
                        style="color:black; margin: 0px; background-color: Transparent;"
                      >Atualizar Noticias</b-button>
                    </b-col>-->
                    <b-col class="d-flex justify-content-end">
                      <b-form-checkbox
                        v-model="validateNews"
                        v-if="filteredsNews.length > 0 || noNewsFromCheckbox"
                        >Esconder Publicadas</b-form-checkbox
                      >
                    </b-col>
                  </b-row>
                  <b-col>
                    <b-col
                      class="not-found-section3 col-sm-12"
                      v-if="filteredsNews.length == 0"
                    >
                      <b-col class="not-found">
                        <b-row>
                          Sem noticias!
                          <br />Por favor selecione uma Fonte.
                        </b-row>
                      </b-col>
                    </b-col>
                  </b-col>
                  <b-col
                    class="section2News"
                    :id="`section2NewId${news.c_id}`"
                    :key="news.c_id"
                    v-for="news in filteredsNews"
                    name="dNewsItem"
                  >
                    <h6
                      style="
                        font-weight: bold;
                        text-align: left;
                        cursor: pointer;
                      "
                      v-html="news.c_u_Title"
                      v-on:click="editNews(news.c_id, news)"
                    ></h6>
                    <p
                      style="text-align: left; cursor: pointer"
                      v-html="
                        news.c_u_Summary != ''
                          ? news.c_u_Summary.replace(/<[^>]*>?/gm, '')
                          : news.c_u_Summary
                      "
                      v-on:click="editNews(news.c_id, news)"
                    ></p>
                    <b-row class="d-flex justify-content-end">
                      <p>
                        {{
                          new Date(news.c_u_NewsDateCreate).toLocaleDateString(
                            "en-GB",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          ) +
                          " às " +
                          new Date(news.c_u_NewsDateCreate).toLocaleTimeString(
                            "en-GB"
                          )
                        }}
                      </p>
                      <b-col
                        sm="1"
                        v-if="news.c_u_Status == 8 || news.c_u_Status == 10"
                      >
                        <b-button size="sm" class="section2Btn">
                          <fa
                            :icon="['fas', 'upload']"
                            size="lg"
                            style="color: green"
                          />
                        </b-button>
                      </b-col>
                      <b-col sm="1" v-if="news.c_u_Status == 6 || isTrueEdited">
                        <b-button size="sm" class="section2Btn">
                          <fa
                            :icon="['fas', 'clipboard-check']"
                            size="lg"
                            style="color: #d1d6a3"
                          />
                        </b-button>
                      </b-col>
                      <b-col sm="1">
                        <b-button
                          size="sm"
                          class="section2Btn"
                          @click="editNews(news.c_id, news)"
                        >
                          <fa icon="edit" size="lg" style="color: #428bac" />
                        </b-button>
                      </b-col>
                      <b-col sm="1">
                        <!--<b-form-checkbox-group
                          v-model="selectedNews"
                          :options="optionsNews[index]"
                          value-field="item"
                          text-field="name"
                          name="itcNewsItem"
                        ></b-form-checkbox-group>-->
                        <b-form-checkbox
                          v-model="selectedNews"
                          :value="news.c_id"
                          name="itcNewsItem"
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
                <b-col>
                  <b-row class="section2Footer">
                    <b-col class="btn1section2">
                      <b-button
                        style="background-color: rgb(162, 91, 113)"
                        @click="deleteAllNews()"
                        >Apagar</b-button
                      >
                    </b-col>
                    <b-col class="btn2section2">
                      <b-button
                        style="background-color: rgb(160, 205, 99)"
                        @click="publishAllNews()"
                        >Publicar</b-button
                      >
                    </b-col>
                    <b-col class="btn3section2">
                      <b-button
                        style="background-color: rgb(99, 190, 200)"
                        @click="selectAllNews()"
                      >
                        Selec.Tudo</b-button
                      >
                    </b-col>
                    <b-col style="padding: 0px">
                      <b-button
                        style="
                          border-radius: 20px;
                          background-color: rgb(231, 242, 245);
                          color: rgb(66, 139, 172);
                          padding: 0.275rem 0.55rem;
                        "
                        @click="clickedScrolll()"
                        >Ver Mais</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-col>
            <!-- NEWS EDITION -->
            <b-col sm="6" class="section3Div">
              <b-col style="display: inline">
                <b-col class="section1Title">
                  <p>Edição de Noticia</p>
                </b-col>
                <b-col class="section3">
                  <b-col class="not-found-section3 col-sm-12" v-if="!isHidden">
                    <b-col class="not-found">
                      <b-row>
                        Nenhuma noticia selecionada!
                        <br />Por favor selecione uma Noticia.
                      </b-row>
                    </b-col>
                  </b-col>
                  <b-col v-if="isHidden">
                    <b-col
                      v-if="
                        newsArray.c_u_Status == 6 || newsArray.c_u_Status == 11
                      "
                    >
                      <p class="isEditedNewUser">
                        <fa
                          class="label"
                          :icon="['fas', 'exclamation-triangle']"
                          size="lg"
                          style="color: orange"
                        />
                        Noticia editada pelo utilizador {{ getUserInfoEdit }} no dia
                        {{ getFormatedNewsEditedDate }}
                      </p>
                    </b-col>
                    <b-col
                      v-if="
                        newsArray.c_u_Status == 8 || newsArray.c_u_Status == 10
                      "
                    >
                      <p class="isEditedNewUser">
                        <fa
                          class="label"
                          :icon="['fas', 'exclamation-triangle']"
                          size="lg"
                          style="color: orange"
                        />
                        Noticia publicada pelo utilizador {{ getUserInfoPublish }}
                      </p>
                    </b-col>
                    <b-col v-bind:style="{ display: newsArray.c_u_Type == 0 ? 'inherit' : 'none' }">
                      <h6 class="section3Title">Fonte</h6>
                      <v-select
                        v-model="newsArray.c_r_Source"
                        :options="optionsFilterSource"
                        label="item"
                        :reduce="(item) => item.code"
                        style="background-color: white"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                    <b-col v-bind:style="{ display: newsArray.c_u_Type == 0 ? 'inherit' : 'none' }">
                      <h6 class="section3Title">Tipo de Noticia</h6>
                      <v-select
                        v-model="newsArray.c_u_NewsOriginType"
                        :options="optionsNewsOriginType"
                        label="item"
                        :reduce="(item) => item.code"
                        style="background-color: white"
                      >
                        <span slot="no-options"
                          >Não foram obtidos resultados</span
                        >
                      </v-select>
                    </b-col>
                    <b-col v-bind:style="{ display: newsArray.c_u_Type == 0 ? 'inherit' : 'none' }">
                      <h6 class="section3Title">Programa</h6>
                      <b-form-input
                        v-model="newsArray.c_u_News_MMS_ProgramName"
                      ></b-form-input>
                    </b-col>
                    <b-col>
                      <h6 class="section3Title">Titulo</h6>
                      <b-form-textarea
                        id="textarea"
                        v-model="newsArray.c_u_Title"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </b-col>
                    <b-col>
                      <h6 class="section3Title">Data/Hora</h6>
                      <b-row>
                        <b-col sm="6">
                          <b-form-input type="date" v-model="_newsDate"></b-form-input>
                        </b-col>
                        <b-col sm="6">
                          <b-form-input type="time" v-model="_newsTime"></b-form-input>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <h6 class="section3Title">Resumo</h6>
                      <editor id="taEditSummary"
                        apiKey="l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl"
                        licenseKey="gpl"
                        v-model="newsArray.c_u_Summary"
                        :init="{
                          height: 250,
                          menubar: true,
                          entity_encoding: 'raw',
                          toolbar1:
                            'styleselect | bold italic | alignleft aligncenter alignright alignjustify',
                        }"
                      />
                    </b-col>
                    <b-col v-if="isNotCreatedNew">
                      <h6 class="section3Title">Imagem</h6>
                      <b-col class="section3Image">
                        <b-row class="section3ImageMargin">
                          <b-col sm="6">
                            <b-col>
                              <img
                                id="output"
                                style="width: 200px; height: 200px"
                              />
                              <b-row>
                                <b-col class="imageBtnStyle">
                                  <fa
                                    class="label"
                                    :icon="['fa', 'search-plus']"
                                    size="lg"
                                    style="cursor: pointer"
                                    @click="openEnLargeImg"
                                  />
                                </b-col>
                                <b-col class="imageBtnStyle">
                                  <fa
                                    class="label"
                                    style="cursor: pointer"
                                    :icon="['fa', 'times']"
                                    size="lg"
                                    @click="deleteImg"
                                  />
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-col>
                          <b-col>
                            <b-col class="uploadBtn">
                              <fa
                                class="label"
                                :icon="['fas', 'plus']"
                                size="lg"
                              />
                              <input
                                id="files"
                                name="files"
                                type="file"
                                @change="uploadFiles('files', newsArray.c_id)"
                              />
                            </b-col>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <!-- The Modal -->
                    <div id="myModal" class="modal">
                      <span class="close">&times;</span>
                      <img class="modal-content" id="img01" />
                      <div id="caption"></div>
                    </div>
                    <b-col>
                      <h6 class="section3Title">Media <small>(mp3, mp4)</small></h6>
                      <b-col class="section3Image">
                        <b-row class="section3ImageMargin">
                          <b-col sm="6" id="fileVideoAudio2">
                            <input
                              id="filesMedia2"
                              name="filesMedia2"
                              type="file"
                              accept=".mp3,.mp4"
                              @change="uploadFilesMedia('filesMedia2', newsArray.c_id)"
                              @click="$event.target.value=''"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <b-col>
                      <h6 class="section3Title">Conteúdo</h6>
                      <editor id="taEditContent"
                        apiKey="l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl"
                        licenseKey="gpl"
                        v-model="newsArray.c_u_Content"
                        :init="this.configTinyMce"
                      />
                      <b-button v-if="selectedThematics.length == 0"
                          style="
                            background-color: rgb(44, 99, 112);
                            margin-top: 5px;
                          "
                          @click="findThematics2()"
                          >Reconhecer temáticas no texto</b-button
                        >
                      <div id="imageUpload" class="hidden"></div>
                    </b-col>
                    <b-col v-if="isNotCreatedNew">
                      <h6 class="section3Title">Tematicas</h6>
                      <b-col @drop="drop" @dragover="allowDrop" sm="12">
                        <b-row
                          v-if="selectedThematics.length == 0"
                          class="d-flex justify-content-center"
                        >
                          <p style="font-weight: bold">
                            Não existem temáticas associadas
                          </p>
                        </b-row>
                        <b-row v-if="selectedThematics.length > 0" class="thematics">
                          <p
                            class="thematic"
                            v-for="(item, index) in selectedThematics"
                            :key="index"
                            :data-id="`${item.id}`"
                          >
                            {{ item.wordName }}
                            <span style="text-align: right">
                              <fa
                                class="thematicRemove"
                                :icon="['fas', 'times']"
                                size="sm"
                                style="color: black; cursor: pointer"
                                @click="deleteThematic(index, newsArray.c_id)"
                              />
                            </span>
                          </p>
                        </b-row>
                      </b-col>
                    </b-col>
                    <b-row>
                      <b-col sm="4">
                        <h6 class="section3Title">FAV</h6>
                        <v-select
                          v-model="newsArray.c_u_NewsidxFav"
                          style="background-color: white"
                          :options="optionsFavView"
                          append-to-body
                          :calculate-position="withPopper"
                          label="id"
                          :reduce="(fav) => fav.id"
                        >
                          <span slot="no-options"
                            >Não foram obtidos resultados</span
                          >
                        </v-select>
                      </b-col>
                      <b-col sm="8">
                        <h6 class="section3Title">AVE</h6>
                        <v-select
                          v-model="newsArray.c_u_NewsAVE"
                          id="AVEdropDown"
                          append-to-body
                          :calculate-position="withPopper"
                          :options="optionsAve"
                          label="newAve"
                          :reduce="(newAve) => newAve.id"
                        >
                          <span slot="no-options"
                            >Não foram obtidos resultados</span
                          >
                        </v-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="4">
                        <h6 class="section3Title">Página</h6>
                        <b-input 
                          type="number"
                          min="0"
                          v-model="newsArray.c_u_NewsPageNumber"
                        ></b-input>
                      </b-col>
                      <b-col sm="8">
                        <h6 class="section3Title">Jornalista</h6>
                        <v-select
                          taggable
                          label="name"
                          append-to-body
                          :calculate-position="withPopper"
                          style="background-color: white"
                          id="journalistDropDown"
                          v-model="newsArray.c_r_Journalist"
                          :options="optionsJournalists"
                          :reduce="(journalist) => journalist.id ? journalist.id : journalist"
                          @input="(journalist) => createJournalist(journalist)"
                        >
                          <span slot="no-options"
                            >Não foram obtidos resultados</span
                          >
                        </v-select>
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 10px">
                      <b-col sm="1">
                        <b-form-checkbox
                          v-model="newsArray.c_u_isHighlighted"
                          value="true"
                          unchecked-value="false"
                          class="section3Title"
                          >Destaque</b-form-checkbox
                        >
                      </b-col>
                    </b-row>
                    <b-row v-if="newsArray.c_u_UrlNews != ''">
                      <b-col class="NewsExtractedFrom">
                        <h6 class="section3Title">Noticia extraida de:</h6>
                        <a
                          style="text-align: left; font-size: 12px"
                          :href="`${newsArray.c_u_UrlNews}`"
                          target="_blank"
                          >{{ newsArray.c_u_UrlNews }}</a
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
                <b-col class="section2Footer" v-if="isHidden">
                  <b-row class="d-flex justify-content-end">
                    <b-col sm="3">
                      <b-button
                        style="background-color: rgb(162, 91, 113)"
                        @click="deleteEditNew(newsArray)"
                        >Apagar</b-button
                      >
                    </b-col>
                    <b-col sm="3">
                      <b-button
                        style="background-color: rgb(99, 190, 200)"
                        @click="postEditNew(newsArray)"
                        >Guardar</b-button
                      >
                    </b-col>
                    <b-col sm="3">
                      <b-button
                        style="background-color: rgb(160, 205, 99)"
                        @click="publishEditedNew(newsArray)"
                        >Publicar</b-button
                      >
                    </b-col>
                    <b-col sm="3">
                      <b-button
                        style="background-color: rgb(160, 205, 99)"
                        @click="copyEditedNew(newsArray)"
                        >Descarregar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-col>
            <b-col class="section4Div" sm="1" style="padding: 0px" v-on:keyup="thematicKB($event)">
              <b-col style="display: inline; overflow: hidden">
                <b-col class="section1Title">
                  <p>Tematicas</p>
                </b-col>
                <b-col
                  v-if="!isHidden"
                  style="background-color: rgb(242, 242, 242); height: 100%"
                ></b-col>
                <b-col v-if="isHidden">
                  <b-row style="margin-bottom: 20px">
                    <b-col sm="12" style="padding: 0px">
                      <span class="filtersTitle">Pesquisa</span>
                    </b-col>
                    <b-col style="padding: 0px">
                      <b-form-input v-model="thematicsSearch" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  class="section4Themes"
                  id="sectionThems"
                  v-if="isHidden || isNotCreatedNew"
                >
                  <b-col
                    class="thematicStyle"
                    v-for="(item, index) in thematicItems"
                    :key="index"
                    :id="`drag${item.id}`"
                    :data-id="`${item.id}`"
                    draggable="false"
                    @dragstart="drag"
                    @click="drag(item)"
                    >{{ item.wordName }}</b-col
                  >
                </b-col>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-modal id="modal-logout" ref="modal-logout" title="Aviso" ok-only @hidden="handleModelLogoutHide">
        <p class="my-4">A sua sessão expirou. Para continuar, por favor, efetue login.</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import Editor from "@tinymce/tinymce-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import resize from "vue-element-resize-detector";
import { createPopper } from "@popperjs/core";
import Config from "../config.loader";
import $ from "jquery";
Vue.use(resize);
export default {
  name: "NewsEdition",

  data() {
    return {
      newsDate: {
				d: '01',
				m: '01',
				y: '2020'
			},
      newsTime: {
				h: '00',
				m: '00'
			},
      isHidden: false,
      isFiltered: 0,
      noNewsFromCheckbox: false,
      isNotCreatedNew: true,
      endpointSources: "Sources",
      lo: _,
      placement: "top",
      endpointNews: "News",
      isTrueEdited: false,
      isTruePublish: false,
      filtersUsers: [],
      endpointUsers: "Users",
      endpointNewsBySource: "News/BySource",
      endpointUsers: "Users",
      endpointJournalist: "Journalists",
      endpointAVE: "VAVEs",
      endpointThemes: "VThemes",
      endpointThemeWords: "ThemeWords",
      optionsFilterSource: [],
      selectedFilterSource: [],
      selectedFilterUsers: [],
      thematicsSearch: "",
      imageArray: [],
      journalists: [],
      newsForLength: [],
      optionsJournalists: [],
      filteredText: "",
      sourceOfCreatedNew: 0,
      contentOfCreatedNew: "",
      createdNew: {
        c_r_Journalist: null,
        c_u_ProcessedDate: "",
        c_u_NumberOfGetTries: 0,
        c_u_NumberOfExtractTries: 0,
        c_u_RawNews: "",
        c_u_ExtractionMethod: "0,0,0,0",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_UrlNews: "",
        c_r_Source: 0,
        c_u_Content: "",
        c_u_ExternalID: 0,
        c_u_ExtractionMethod: "",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_Image: "",
        c_u_Keywords: "",
        c_u_NewsAVE: 0,
        c_u_NewsCreateByUser: null,
        c_u_NewsDateCreate: "",
        c_u_NewsFilePath: null,
        c_u_NewsOriginType: 0,
        c_u_News_MMS_ProgramName: "",
        c_u_NewsThumbnail: "",
        c_u_NewsidxFav: null,
        c_u_ProcessedDate: "",
        c_u_Status: 5,
        c_u_Summary: "",
        c_u_Title: "",
        c_u_Type: 0,
        c_u_isHighlighted: false,
        c_u_NewsEditByUser: null,
        c_u_NewsDateEdit: "",
        c_u_NewsPublishedByUser: null,
        c_u_NewsPageNumber: null
      },
      optionsSourceForCreate: [],
      optionsNewsOriginType: [
        { code: 1, item: "TV" },
        { code: 2, item: "Radio" },
        { code: 3, item: "ePaper" },
        { code: 4, item: "Online" },
        { code: 5, item: "RSS" },
      ],
      Vave: [],
      optionsAve: [],
      configTinyMce: {
        height: 500,
        menubar: true,
        paste_data_images: true,
        entity_encoding: "raw",
        plugins: [
          "advlist autolink lists link image media charmap print preview hr anchor pagebreak",
          "searchreplace wordcount visualblocks visualchars code fullscreen",
          "insertdatetime media nonbreaking save table directionality",
          "emoticons template paste textpattern",
        ],
        toolbar1:
          "styleselect | bold italic | alignleft aligncenter alignright alignjustify | link image media",
        image_advtab: true,
        document_base_url: `${this.getUrl}`,
        file_picker_callback: function (cb, value, meta) {
          var div = document.getElementsByClassName("hidden");
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");

          $("#imageUpload").append(input);
          input.onchange = function () {
            var file = this.files[0];

            var reader = new FileReader();
            reader.onload = function () {
              var id = "blobid" + new Date().getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(",")[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              cb(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
      },
      endpointImages: this.getUrl,
      sourcesArray: [],
      filteredSourceArray: [],
      selectedNews: [],
      optionsNews: [[]],
      thematicItems: [],
      optionsStatus: [
        { code: 4, status: "Por Validar" },
        { code: 5, status: "Por Editar" },
        { code: 6, status: "Editadas" },
        { code: 7, status: "Copiadas" },
        { code: 8, status: "Publicadas" },
      ],
      optionsTypeNews: [
        { code: 0, type: "Sistema" },
        // { code: 1, type: "MMS" },
        // { code: 2, type: "RSS" },
        { code: 3, type: "Scraper" },
        // { code: 4, type: "OCR" },
      ],
      selectedFilterType: [],
      selectedFilterStatus: [],
      newsArray: [],
      filtersDates: {
        startDate: "",
        endDate: "",
      },
      filterStartDate: "",
      filterEndDate: "",
      filters: {
        source: "",
        thematic: "",
        startDate: "",
        endDate: "",
        status: 0,
        text: "",
      },
      optionsFilterTheme: [],
      selectedFilterTheme: [],
      filteredsNews: [],
      filteredNewsBySource: [],
      selectedThematics: [],
      thematicsArray: [],
      filteredData: [],
      getUserInfoCreate: "",
      getUserInfoEdit: "",
      getUserInfoPublish: "",
      getFormatedNewsCreatedDate: "",
      getFormatedNewsEditedDate: "",
      getFormatedNewsPublishedDate: "",
      endpointFilteredNews: "ByFilterSource",
      endpointFiltereds: "ByFilter",
      endpointFilteredByDate: "ByFilterDate",
      endpointFilteredByType: "ByFilterType",
      endpointFilteredByStatus: "ByFilterStatus",
      endpointFilteredByUser: "ByFilterUser",
      endpointFilteredByTheme: "ByFilterTheme",
      eachNewBySource: [],
      postImageData: {},
      filtersHeight: 0,
      optionsFavView: [],
      images: [],
      imagePath: [],
      scrolled: false,
      mediaPath: {},
      sourceIdForScroll: 0,
      clickedEventSourceId: 0,
      clickedEventSourceName: "",
      neededArrayOfNews: [],
      itsAudio: false,
      validateNews: false,
      itsVideo: false,
      neededId: 0,
      neededNews: 0,
      itemsThemeWords: [],
      newThematicItems: [],
      isFilteredData: false,
      savedCreatedNew: {},
      idOfCreatedNew: 0,
      themeWordsToFind: [],
      themeProhibitedWordsToFind: [],
      isThematicDelete: false,
      isThematicDeleteId: 0,
      endpointFilteredSection: "ByFilteredSection",
      dataFromFilter: [],
      valueOfScroll: false,
    };
  },
  watch: {
    async isFiltered(to, from) {
      if (to == "1") {
        let newSourceArray = [];
        for (let index = 0; index < this.sourcesArray.length; index++) {
          if (
            this.newsForLength[this.sourcesArray[index].c_id].totalOfNumber != 0
          ) {
            newSourceArray.push(this.sourcesArray[index]);
          }
        }
        let ScraperSources = _.filter(newSourceArray, (o) => {
          return o.c_u_Status == 1;
        });
        
        //old version
        /*this.filteredSourceArray = _.sortBy(ScraperSources, [
          function (o) {
            return o.c_u_ReferenceSource;
          },
        ]);*/

        //new version - the webapi has pre-ordered the results
        this.filteredSourceArray = ScraperSources;
      }
      if (to == "0") {
        let ScraperSources = _.filter(this.sourcesArray, (o) => {
          return o.c_u_Status == 1;
        });

        //old version
        /*this.filteredSourceArray = _.sortBy(ScraperSources, [
          function (o) {
            return o.c_u_ReferenceSource;
          },
        ]);*/

        //new version - the webapi has pre-ordered the results
        this.filteredSourceArray = ScraperSources;
      }
    },
    selectedThematics(to, from) {
      //debugger;
      if (this.thematicsSearch != "") {
        this.thematicsSearch = "";
      }
      if (this.isThematicDelete == false) {
        to.forEach((to) => {
          let checkedThemes = _.filter(this.thematicItems, (o) => {
            return o.id == to.id;
          });

          _.remove(this.thematicItems, function (n) {
            return n.id == to.id;
          });
          if (checkedThemes[0] != undefined) {
            this.thematicItems.unshift(checkedThemes[0]);
          }
        });

        let section =
          document.getElementById("sectionThems") != undefined
            ? document.getElementById("sectionThems").childNodes
            : [];
        for (let index = 0; index < this.selectedThematics.length; index++) {
          try {
            if (section[index].style.color != "black") {
              section[index].style =
                "color:Black; font-weight: bold; background-color: rgb(160, 205, 99)";
              // section[index].style = "font-weight: bold; background-color:green";
            }
          } catch (err) {}
        }
      } else {
        this.isThematicDelete = false;
        // let id = this.isThematicDeleteId;
        // let checkedThemes = _.filter(this.thematicItems, o => {
        //   return o.id == id;
        // });
        // let indexOfid = _.indexOf(this.thematicItems, checkedThemes[0]);
        // console.log(indexOfid)
        // this.thematicItems.splice(indexOfid, 1);
        // // _.remove(this.thematicItems, function(n) {
        // //   return n.id == id;
        // // });
        // let number = this.selectedThematics.length;
        // this.thematicItems.splice(number, 0,checkedThemes[0]);
      }
    },
    async thematicsSearch(to, from) {
      //debugger;
      if (this.thematicsSearch != "") {
        var section = [];
        if (document.getElementsByClassName("section4Div")[0].style.display != "none") {
          section =
            document.getElementsByClassName("section4Themes")[0] != undefined
              ? document.getElementsByClassName("section4Themes")[0].childNodes
              : [];
        }
        else if (document.getElementsByClassName("section6Div")[0].style.display != "none") {
          section =
            document.getElementsByClassName("section6Themes")[0] != undefined
              ? document.getElementsByClassName("section6Themes")[0].childNodes
              : [];
        }
        
        for (let index = 0; index < this.thematicItems.length; index++) {
          try {
            if (section[index].style.color == "black") {
              section[index].style = "";
            }
          } catch (err) {}
        }

        this.thematicItems = _.filter(this.newThematicItems, (theme) => {
          return theme.wordName
            ? theme.wordName
                .toLowerCase()
                .indexOf(this.thematicsSearch.toLowerCase()) > -1
            : false;
        });
        this.thematicItems = _.uniqBy(this.thematicItems, "wordName");
      } else {
        this.isThematicDelete == false;
        this.thematicItems = _.xor(this.newThematicItems);
        setTimeout(() => {
          //section is always undefined because this is executed before it is drawn; using a timed function to execute and not be undefined
          var section = [];
          if (document.getElementsByClassName("section4Div")[0].style.display != "none") {
            section =
              document.getElementsByClassName("section4Themes")[0] != undefined
                ? document.getElementsByClassName("section4Themes")[0].childNodes
                : [];
          }
          else if (document.getElementsByClassName("section6Div")[0].style.display != "none") {
            section =
              document.getElementsByClassName("section6Themes")[0] != undefined
                ? document.getElementsByClassName("section6Themes")[0].childNodes
                : [];
          }
          //console.log("section", section);
          //console.log("this.selectedThematics", this.selectedThematics);
          //console.log("this.thematicItems", this.thematicItems);
          for (let index = 0; index < this.selectedThematics.length; index++) {
            this.thematicItems.unshift(this.selectedThematics[index]);
            try {
              section[index].style =
                "color:Black; font-weight: bold; background-color: rgb(160, 205, 99)";
            } catch (err) {}
          }
          this.thematicItems = _.uniqBy(this.thematicItems, "wordName");
        }, 1500);
      }
    },
    async validateNews(to, from) {
      //debugger;
      if (to == true) {
        const predicate = (start, end) => ({ c_u_Status }) =>
          c_u_Status != start && c_u_Status != end;

        this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
        if (this.filteredsNews.length == 0) {
          this.noNewsFromCheckbox = true;
        } else {
          this.noNewsFromCheckbox = false;
        }
      } else {
        if (this.isFilteredData == true) {
          this.filteredsNews = this.dataFromFilter;
        } else {
          this.filteredsNews = this.neededArrayOfNews;
        }
      }
    },
    async sourceOfCreatedNew(to, from) {
      if (to != null) {
        this.Vave = [];
        this.optionsAve = [];
        //receive the list of AVES
        this.$api.data.endpoint = this.endpointAVE;
        this.Vave = await this.$api.data.findOneById(to);
        for (let index = 0; index < this.Vave.length; index++) {
          Vue.set(this.optionsAve, index, {
            id: this.Vave[index].id,
            newAve: this.Vave[index].aveText,
          });
        }
      }
    },
    async idOfCreatedNew(to, from) {
      // create the thematic
      for (let index = 0; index < this.selectedThematics.length; index++) {
        let objectThemesWord = {
          c_u_Words: this.selectedThematics[index].wordName,
          c_u_ThemeId: this.selectedThematics[index].id,
        };
        this.$api.data.endpoint = "ThemeWords";
        let findOneByIdThemes = _.find(
          await this.$api.data.find(),
          function (o) {
            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
          }
        );
        this.$api.data.endpoint = `ThemeWordsNews/Thematics/${to}`;
        let findThemeNews = _.find(await this.$api.data.find(), function (r) {
          return (
            r.themeNews == to && r.themeWordId == findOneByIdThemes.c_u_ThemeId
          );
        });
        if (findThemeNews == undefined) {
          this.$api.data.endpoint = "ThemeWordsNews";
          let objectThemes = {
            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
            c_u_Type: 0,
            c_u_Status: 1,
            c_r_ThemeWords: findOneByIdThemes.c_id,
            c_r_News: to,
          };
          await this.$api.data.create(objectThemes);
        }
      }

      this.imagesUpload(to);
      //clear all data after its created
      this.contentOfCreatedNew = "";
      this.createdNew = {
        c_r_Journalist: null,
        c_u_ProcessedDate: "",
        c_u_NumberOfGetTries: 0,
        c_u_NumberOfExtractTries: 0,
        c_u_RawNews: "",
        c_u_ExtractionMethod: "0,0,0,0",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_UrlNews: "",
        c_r_Source: 0,
        c_u_Content: "",
        c_u_ExternalID: 0,
        c_u_ExtractionMethod: "",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_Image: "",
        c_u_Keywords: "",
        c_u_NewsAVE: 0,
        c_u_NewsCreateByUser: null,
        c_u_NewsDateCreate: "",
        c_u_NewsFilePath: null,
        c_u_NewsOriginType: this.createdNew.c_u_NewsOriginType,
        c_u_News_MMS_ProgramName: this.createdNew.c_u_News_MMS_ProgramName,
        c_u_NewsThumbnail: "",
        c_u_NewsidxFav: null,
        c_u_ProcessedDate: "",
        c_u_Status: 5,
        c_u_Summary: "",
        c_u_Title: "",
        c_u_Type: 0,
        c_u_isHighlighted: false,
        c_u_NewsPageNumber: null
      };
      this.selectedThematics = [];
      let section =
        document.getElementById("sectionThems") != undefined
          ? document.getElementById("sectionThems").childNodes
          : [];
      for (let index = 0; index < section.length; index++) {
        if (section[index].style.color == "black") {
          section[index].style.color = null;
          section[index].style.backgroundColor = null;
          section[index].style.fontWeight = null;
        }
      }
      this.journalists = [];
      this.Vave = [];

      try { this.postImageData = null; } catch(err) { }
      try { this.mediaPath = null; } catch(err) { }
      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
      document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
      document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
      document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
      document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
      document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
      document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

      //refresh the number of news in the section of sources
      //old NewsLength
      /*for (let index = 0; index < this.sourcesArray.length; index++) {
        this.$api.data.endpoint = `Sources/NewsLength/${this.sourcesArray[index].c_id}`;
        this.newsForLength[
          this.sourcesArray[index].c_id
        ] = await this.$api.data.find();
      }*/

      //new NewsLength
      this.$api.data.endpoint = "Sources/NewsLength";
      let NewsLengthResponse = await this.$api.data.find();
      //console.log("NewsLengthResponse", NewsLengthResponse);
      //console.log("this.sourcesArray", this.sourcesArray);
      for (let index = 0; index < this.sourcesArray.length; index++) {
        let NewsLengthForSource = { totalOfNumber: 0, isTrue: false };
        for (let index2 = 0; index2 < NewsLengthResponse.length; index2++) {
          let NewsLengthResponseItem = NewsLengthResponse[index2];
          if (
            NewsLengthResponseItem.sourceID == this.sourcesArray[index].c_id
          ) {
            NewsLengthForSource = {
              totalOfNumber: NewsLengthResponseItem.numNews,
              isTrue: NewsLengthResponseItem.hasEditedNews,
            };
            break;
          }
        }
        this.newsForLength[this.sourcesArray[index].c_id] = NewsLengthForSource;
      }
      //console.log("this.newsForLength", this.newsForLength);

      this.$forceUpdate();
    },
    // valueOfScroll(to,from){
    //   if(to == false){
    //     this.valueOfScroll = true;
    //   }else{
    //     this.valueOfScroll = false;
    //   }
    // }
  },
  computed: {
    ...mapGetters({
      getUserId: "auth/getUserId",
      getUrl: "api/getUrl",
    }),
    _newsDate: {
			get(){
				let {d, m, y} = this.newsDate;
				return `${y}-${m}-${d}`;
			},
			set(newVal){
				let [y, m, d] = newVal.split('-');
				this.newsDate = {y, m, d};
			}
		},
    _newsTime: {
			get(){
				let {h, m} = this.newsTime;
				return `${h}:${m}`;
			},
			set(newVal){
				let [h, m] = newVal.split(':');
				this.newsTime = {h, m};
			}
		},
  },
  components: {
    VueEditor,
    editor: Editor,
    vSelect,
  },

  methods: {
    handleModelLogoutHide(e) {
      this.$api.logout();
    },
    onResize(e) {
      if (window.innerWidth < 1600) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML =
          "Atualizar";
        if (window.innerHeight < 750) {
          let number =
            document.getElementsByClassName("section2Div")[0].clientHeight *
            0.5;
          let numberOfContentSection1 =
            document.getElementsByClassName("section1")[0].clientHeight * 0.5;
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${numberOfContentSection1}px`;
          document.getElementsByClassName("section4Div")[0].style.height =
            "80%";
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName("section6Div")[0].style.height =
            "80%";
        } else {
          let valueOfSection2 = "60%";
          let valueOfSection3 = "60%";
          let valueOfSection4 = "85%";
          let valueOfSection5 = "60%";
          let valueOfSection6 = "85%";
          let valueOfContentSection1 = "50%";
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${valueOfContentSection1}`;
          document.getElementsByClassName(
            "section4Div"
          )[0].style.height = `${valueOfSection4}`;
          document.getElementsByClassName(
            "section6Div"
          )[0].style.height = `${valueOfSection6}`;
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${valueOfSection2}`;
          // section3 if screen is less than 1600
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${valueOfSection3}`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${valueOfSection5}`;
        }

        document.getElementsByClassName("btn1section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btnClear")[0].style = "";
        document.getElementsByClassName("btnSearch")[0].style =
          "margin-right: 25px;padding: 0px;";
        document.getElementsByClassName("ifLowWidth")[0].style =
          "display:none;";
        document.getElementsByClassName("textBtn")[0].style =
          "padding:0px 2px;";
      }
      if (window.innerWidth < 1350) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML =
          "Atualizar";
        if (window.innerHeight < 750) {
          let number =
            (document.getElementsByClassName("section2Div")[0].clientHeight -
              this.filtersHeight) *
            0.55;
          let numberOfContentSection1 =
            document.getElementsByClassName("section1")[0].clientHeight * 0.5;
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName("section4Div")[0].style.height =
            "60%";
          document.getElementsByClassName("section6Div")[0].style.height =
            "60%";
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${number}px`;
        } else {
          let valueOfSection2 = "55%";
          let valueOfSection3 = "55%";
          let valueOfSection4 = "75%";
          let valueOfSection5 = "53%";
          let valueOfSection6 = "70%";
          let valueOfContentSection1 = "50%";
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${valueOfContentSection1}`;
          document.getElementsByClassName(
            "section4Div"
          )[0].style.height = `${valueOfSection4}`;
          document.getElementsByClassName(
            "section6Div"
          )[0].style.height = `${valueOfSection6}`;
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${valueOfSection2}`;
          // section3 if screen is less than 1600
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${valueOfSection3}`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${valueOfSection5}`;
        }

        document.getElementsByClassName("btn1section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btnClear")[0].style = "display:none";
        document.getElementsByClassName("btnSearch")[0].style = "display:none";
        document.getElementsByClassName("ifLowWidth")[0].style = "";
        document.getElementsByClassName("textBtn")[0].style =
          "padding:0px 2px; margin-right:25px";
      }
      if (window.innerWidth <= 1200) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML =
          "Atualizar";
        if (window.innerHeight < 750) {
          let number =
            (document.getElementsByClassName("section2Div")[0].clientHeight -
              this.filtersHeight) *
            0.5;
          let numberOfContentSection1 =
            document.getElementsByClassName("section1")[0].clientHeight * 0.45;
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${numberOfContentSection1}px`;
          document.getElementsByClassName("section4Div")[0].style.height =
            "60%";
          document.getElementsByClassName("section6Div")[0].style.height =
            "60%";
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${number}px`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${number}px`;
        } else {
          let valueOfSection2 = "60%";
          let valueOfSection3 = "60%";
          let valueOfSection4 = "65%";
          let valueOfSection5 = "60%";
          let valueOfSection6 = "65%";
          let valueOfContentSection1 = "45%";
          document.getElementsByClassName(
            "contentOfSection1"
          )[0].style.height = `${valueOfContentSection1}`;
          document.getElementsByClassName(
            "section4Div"
          )[0].style.height = `${valueOfSection4}`;
          document.getElementsByClassName(
            "section6Div"
          )[0].style.height = `${valueOfSection6}`;
          document.getElementsByClassName(
            "section2"
          )[0].style.height = `${valueOfSection2}`;
          // section3 if screen is less than 1600
          document.getElementsByClassName(
            "section3"
          )[0].style.height = `${valueOfSection3}`;
          document.getElementsByClassName(
            "section5"
          )[0].style.height = `${valueOfSection5}`;
        }
        // let valueOfSection2 = "55%";
        // let valueOfSection3 = "55%";
        // document.getElementsByClassName(
        //   "section2"
        // )[0].style.height = `${valueOfSection2}`;
        document.getElementsByClassName("btn1section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style =
          "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style =
          "padding:0px";

        document.getElementsByClassName("btnClear")[0].style = "display:none";
        document.getElementsByClassName("btnSearch")[0].style = "display:none";
        document.getElementsByClassName("ifLowWidth")[0].style = "";
        document.getElementsByClassName("textBtn")[0].style =
          "padding:0px 2px; margin-right:25px";
        // section3 if screen is less than 1600
        // document.getElementsByClassName(
        //   "section3"
        // )[0].style.height = `${valueOfSection3}`;
      }
      if (window.innerWidth >= 1600) {
        document.getElementsByClassName("section2")[0].style.height = "";
        document.getElementsByClassName("btn1section2")[0].style = "";
        document.getElementsByClassName("btn2section2")[0].style = "";
        document.getElementsByClassName("btn3section2")[0].style = "";
        document.getElementsByClassName("contentOfSection1")[0].style.height =
          "";
        document.getElementsByClassName("section4Div")[0].style.height = "";
        document.getElementsByClassName("section6Div")[0].style.height = "";
        // section3 if screen is less than 1600
        document.getElementsByClassName("section3")[0].style.height = "";
        document.getElementsByClassName("section5")[0].style.height = "";
        document.getElementsByClassName("createBtnFonte")[0].innerHTML =
          "Atualizar SRC";
        document.getElementsByClassName("btnClear")[0].style = "";
        document.getElementsByClassName("ifLowWidth")[0].style =
          "display:none;";
        document.getElementsByClassName("btnSearch")[0].style =
          "margin-right: 25px;padding: 0px;";
        document.getElementsByClassName("textBtn")[0].style =
          "padding:0px 2px;";
      }

      if (e != undefined) {
        if (e.detail.height > this.filtersHeight) {
          document.getElementsByClassName(
            "section2Div"
          )[0].style.height = `calc(100% - ${e.detail.height}px)`;
          document.getElementsByClassName(
            "section3Div"
          )[0].style.height = `calc(100% - ${e.detail.height}px)`;
          //document.body.style = "overflow-y:scroll";
        } else {
          document.getElementsByClassName("section2Div")[0].style.height = "";
          document.getElementsByClassName("section3Div")[0].style.height = "";

          // document.body.style.overflow = "hidden";
          // window.scrollTo(0, 0);
        }
      }
    },
    getLoggedInUserID() {
      var UserID1 = this.getUserId;
      var UserID2 = parseInt(document.getElementById("ithUserID").value, 10);
      if (UserID1) {
        return UserID1;
      }
      else {
        if (Number.isInteger(UserID2)) {
          return UserID2;
        }
        else {
          return 0;
        }
      }
    },

    thematicKBDown() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var FirstElement = null;
      if (ThemesContainer.childElementCount > 0) {
        FirstElement = ThemesContainer.childNodes[0];
      }
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement !== null) {
        var NextElement = CurrentKBElement.nextElementSibling;
        if (NextElement != null) {
          var Elements = ThemesContainer.childNodes;
          for (var i=0; i < Elements.length; i++) {
              Elements[i].setAttribute("kb","0");
          }
          NextElement.setAttribute("kb","1");
          var ScrollTop = NextElement.offsetTop - NextElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
          ThemesContainer.scrollTop = (NextElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0);
        }
      }
      else if (FirstElement != null) {
        var Elements = ThemesContainer.childNodes;
        for (var i=0; i < Elements.length; i++) {
            Elements[i].setAttribute("kb","0");
        }
        FirstElement.setAttribute("kb","1");
        var ScrollTop = FirstElement.offsetTop - FirstElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
        ThemesContainer.scrollTop = (FirstElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0);
      }
    },

    thematicKBUp() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var LastElement = null;
      if (ThemesContainer.childElementCount > 0) {
        LastElement = ThemesContainer.childNodes[ThemesContainer.childElementCount-1];
      }
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement != null) {
        var PreviousElement = CurrentKBElement.previousElementSibling;
        if (PreviousElement != null) {
          var Elements = ThemesContainer.childNodes;
          for (var i=0; i < Elements.length; i++) {
              Elements[i].setAttribute("kb","0");
          }
          PreviousElement.setAttribute("kb","1");
          var ScrollTop = PreviousElement.offsetTop - PreviousElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
          ThemesContainer.scrollTop = (PreviousElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0);
        }
      }
      else if (LastElement != null) {
        var Elements = ThemesContainer.childNodes;
        for (var i=0; i < Elements.length; i++) {
            Elements[i].setAttribute("kb","0");
        }
        LastElement.setAttribute("kb","1");
        var ScrollTop = LastElement.offsetTop - LastElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
        ThemesContainer.scrollTop = (LastElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0);
      }
    },
    
    thematicKBLeft() {
      //debugger;
      try {
        var ThemesContainer = document.getElementById("sectionThems");
        var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
        if (CurrentKBElement != null) {
          var ID = CurrentKBElement.getAttribute("data-id");
          var Section = null;
          if (!this.isNotCreatedNew) {
            //new news
            Section = document.getElementsByClassName("section5")[0];
          }
          else {
            //edit news
            Section = document.getElementsByClassName("section3")[0];
          }
          var ThematicsContainer = Section.querySelector(".thematics");
          var Thematic = ThematicsContainer.querySelector(".thematic[data-id='" + ID + "']");
          var RemoveThematic = Thematic.querySelector(".thematicRemove");
          RemoveThematic.dispatchEvent(new Event('click'));
        }
      }
      catch(err) {}
    },

    thematicKBRight() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement != null) {
        CurrentKBElement.click();
      }
    },

    thematicKB(pEvent) {
      //debugger;
      //console.log("pEvent", pEvent);
      try {
        if(pEvent.keyCode == 40) {
          //key arrow down
          this.thematicKBDown();
        }
        else if(pEvent.keyCode == 38) {
          //key arrow up
          this.thematicKBUp();
        }
        else if(pEvent.keyCode == 37) {
          //key arrow left
          this.thematicKBLeft();
        }
        else if(pEvent.keyCode == 39) {
          //key arrow right
          this.thematicKBRight();
        }
      }
      catch(err) {}
    },

    setInterfaceNewsDateTime(pDateTime) {
      try {
        //debugger;
        //console.log("datetime: " + pDateTime);
        var NewsDate = new Date(moment(pDateTime)._d);  
        var Year = NewsDate.getFullYear();
        var Month = NewsDate.getMonth() + 1;
        Month = (Month < 10 ? "0":"") + Month;
        var Day = NewsDate.getDate();
        Day = (Day < 10 ? "0":"") + Day;

        var Hours = NewsDate.getHours();
        Hours = (Hours < 10 ? "0":"") + Hours;
        var Minutes = NewsDate.getMinutes();
        Minutes = (Minutes < 10 ? "0":"") + Minutes;

        this._newsDate = Year+"-"+Month+"-"+Day;
        this._newsTime = Hours+":"+Minutes;
      }
      catch(err) {}
    },

    async showData() {
      //check if there is an user id; if not then goto login
      if (this.getLoggedInUserID()) { }
      else {
        //this.$bvModal.show("modal-logout");
        this.$refs["modal-logout"].show();
        //this.$api.logout();
        return;
      }

      this.$api.data.endpoint = this.endpointSources;
      this.sourcesArray = await this.$api.data.find();

      //old NewsLength
      /*for (let index = 0; index < this.sourcesArray.length; index++) {
        this.$api.data.endpoint = `Sources/NewsLength/${this.sourcesArray[index].c_id}`;
        this.newsForLength[
          this.sourcesArray[index].c_id
        ] = await this.$api.data.find();
      }*/

      //new NewsLength
      this.$api.data.endpoint = "Sources/NewsLength";
      let NewsLengthResponse = await this.$api.data.find();
      //console.log("NewsLengthResponse", NewsLengthResponse);
      //console.log("this.sourcesArray", this.sourcesArray);
      for (let index = 0; index < this.sourcesArray.length; index++) {
        let NewsLengthForSource = { totalOfNumber: 0, isTrue: false };
        for (let index2 = 0; index2 < NewsLengthResponse.length; index2++) {
          let NewsLengthResponseItem = NewsLengthResponse[index2];
          if (
            NewsLengthResponseItem.sourceID == this.sourcesArray[index].c_id
          ) {
            NewsLengthForSource = {
              totalOfNumber: NewsLengthResponseItem.numNews,
              isTrue: NewsLengthResponseItem.hasEditedNews,
            };
            break;
          }
        }
        this.newsForLength[this.sourcesArray[index].c_id] = NewsLengthForSource;
      }
      //console.log("this.newsForLength", this.newsForLength);

      // order the sources by who have more news
      let ScraperSources = _.filter(this.sourcesArray, (o) => {
        return o.c_u_Status == 1;
      });
      
      //old version
      /*this.filteredSourceArray = _.sortBy(ScraperSources, [
        function (o) {
          return o.c_u_ReferenceSource;
        },
      ]);*/

        //new version - the webapi has pre-ordered the results
        this.filteredSourceArray = ScraperSources;

      for (let index = 0; index < this.sourcesArray.length; index++) {
        Vue.set(this.optionsFilterSource, index, {
          item: this.sourcesArray[index].c_u_ReferenceSource,
          code: this.sourcesArray[index].c_id,
        });
      }

      //receive the favorability from the view table in sql
      this.$api.data.endpoint = "VFavorability";
      let viewFavorability = await this.$api.data.find();
      for (let index = 0; index < viewFavorability.length; index++) {
        Vue.set(this.optionsFavView, index, {
          id: viewFavorability[index].id,
          fav: viewFavorability[index].favorability,
        });
      }

      //receive the themes from the view table in sql
      this.$api.data.endpoint = "VThemes";
      let viewThemes = await this.$api.data.find();
      this.$api.data.endpoint = this.endpointThemeWords;
      this.itemsThemeWords = await this.$api.data.find();

      //debugger;
      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        let id = this.itemsThemeWords[index].c_u_ThemeId;
        let thm = _.find(viewThemes, function (o) {
          return o.id == id;
        });
        this.itemsThemeWords[index] = {
          c_id: this.itemsThemeWords[index].c_id,
          c_u_ThemeId: this.itemsThemeWords[index].c_u_ThemeId,
          c_u_Words: this.itemsThemeWords[index].c_u_Words,
          wordName: thm == undefined ? thm : thm.wordName,
        };
        //console.log("this.itemsThemeWords[index]: ", this.itemsThemeWords[index]);
      }
      _.remove(this.itemsThemeWords, function (n) {
        return n.wordName == undefined;
      });
      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        Vue.set(this.optionsFilterTheme, index, {
          code: this.itemsThemeWords[index].c_u_ThemeId,
          theme: this.itemsThemeWords[index].wordName,
        });
      }
      // for (let index = 0; index < viewThemes.length; index++) {
      //   Vue.set(this.optionsFilterTheme, index, {
      //     code: viewThemes[index].id,
      //     theme: viewThemes[index].wordName
      //   });
      // }

      //receive the users from the table in sql
      this.$api.data.endpoint = this.endpointUsers;
      let usersArray = await this.$api.data.find();
      for (let index = 0; index < usersArray.length; index++) {
        Vue.set(this.filtersUsers, index, {
          id: usersArray[index].userID,
          name: usersArray[index].displayName,
        });
      }
      document
        .getElementById("themeDropDown")
        .getElementsByTagName("ul")[0].style.width = "450px";
      document
        .getElementById("usersDropDown")
        .getElementsByTagName("ul")[0].style.width = "350px";
    },
    async handleScrolll() {
      let that = this;
      $("#section2").on("scroll", function () {
        if (
          $("#section2").prop("scrollHeight") - $("#section2").scrollTop() <=
          Math.ceil($("#section2").height())
        ) {
          that.valueOfScroll = true;
          that.$forceUpdate();
        } else {
          that.valueOfScroll = false;
          that.$forceUpdate();
        }
      });
      // if (this.isFilteredData == false && this.filteredText == "") {
      //   let itsFinal = 0;
      //   let that = this;
      //   let newDataOfNews = [];
      //   $("#section2").on("scroll", async function () {
      //     var scrollPosition = Math.round(
      //       $(this).scrollTop() + $(this).innerHeight(),
      //       10
      //     );
      //     var divTotalHeight =
      //       $(this)[0].scrollHeight +
      //       parseInt($(this).css("padding-top"), 10) +
      //       parseInt($(this).css("padding-bottom"), 10) +
      //       parseInt($(this).css("border-top-width"), 10) +
      //       parseInt($(this).css("border-bottom-width"), 10);
      //     if (scrollPosition == divTotalHeight && itsFinal == 0) {
      //       that.$api.data.endpoint = `News/scrollDown/${that.sourceIdForScroll}/${that.neededArrayOfNews.length}`;
      //       newDataOfNews = await that.$api.data.find();
      //       for (let index = 0; index < newDataOfNews.length; index++) {
      //         that.neededArrayOfNews.push(newDataOfNews[index]);
      //       }
      //       that.filteredsNews = that.neededArrayOfNews;
      //       for (let index = 0; index < that.filteredsNews.length; index++) {
      //         that.optionsNews[index] = [];
      //         that.optionsNews[index].push({
      //           item: that.filteredsNews[index].c_id,
      //           name: "",
      //         });
      //       }
      //     }

      //     itsFinal++;
      //   });
      //   if (this.validateNews == true) {
      //     // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
      //     //   return o.c_u_Status != 8;
      //     // });
      //     const predicate = (start, end) => ({ c_u_Status }) =>
      //   c_u_Status != start && c_u_Status != end;

      //   this.filteredsNews = this.filteredsNews.filter(predicate(8,10));
      //   } else {
      //     this.filteredsNews = this.neededArrayOfNews;
      //   }
      // }
      // if (this.isFilteredData == true) {
      //   let itsFinal = 0;
      //   let that = this;
      //   $("#section2").on("scroll", async function () {
      //     var scrollPosition = Math.round(
      //       $(this).scrollTop() + $(this).innerHeight(),
      //       10
      //     );
      //     var divTotalHeight =
      //       $(this)[0].scrollHeight +
      //       parseInt($(this).css("padding-top"), 10) +
      //       parseInt($(this).css("padding-bottom"), 10) +
      //       parseInt($(this).css("border-top-width"), 10) +
      //       parseInt($(this).css("border-bottom-width"), 10);
      //     if (scrollPosition == divTotalHeight && itsFinal == 0) {
      //       if (
      //         that.filtersDates.startDate != "" &&
      //         that.filtersDates.endDate == ""
      //       ) {
      //         let todaysDate = new Date();
      //         todaysDate =
      //           todaysDate.getFullYear() +
      //           "-" +
      //           (todaysDate.getMonth() + 1 < 10
      //             ? "0" + (todaysDate.getMonth() + 1)
      //             : todaysDate.getMonth() + 1) +
      //           "-" +
      //           (todaysDate.getDate() < 10
      //             ? "0" + todaysDate.getDate()
      //             : todaysDate.getDate());
      //         that.filtersDates.endDate = todaysDate;
      //       }
      //       let urlEncoderSource =
      //         that.selectedFilterSource.length != 0
      //           ? encodeURIComponent(that.selectedFilterSource.toString())
      //           : 0;
      //       let startDateFilter =
      //         that.filtersDates.startDate == ""
      //           ? 0
      //           : that.filtersDates.startDate;
      //       let endDateFilter =
      //         that.filtersDates.endDate == "" ? 0 : that.filtersDates.endDate;
      //       let statusFilter =
      //         typeof that.selectedFilterStatus != "number"
      //           ? 0
      //           : that.selectedFilterStatus;
      //       let typeFilter =
      //         typeof that.selectedFilterType != "number"
      //           ? 20
      //           : that.selectedFilterType;
      //       let themeFilter =
      //         typeof that.selectedFilterTheme != "number"
      //           ? 0
      //           : that.selectedFilterTheme;
      //       let userFilter =
      //         typeof that.selectedFilterUsers != "number"
      //           ? 0
      //           : that.selectedFilterUsers;
      //       let textFilter = that.filteredText == "" ? 0 : that.filteredText;

      //       //Call the endpoint of filter
      //       that.$api.data.endpoint = `${that.endpointNews}/${that.endpointFilteredSection}/${urlEncoderSource}/${typeFilter}/${themeFilter}/${startDateFilter}/${endDateFilter}/${statusFilter}/${userFilter}/${textFilter}/${that.dataFromFilter.length}`;
      //       let news = await that.$api.data.find();
      //       for (let index = 0; index < news.length; index++) {
      //         that.dataFromFilter.push(news[index]);
      //       }
      //       that.filteredsNews = that.dataFromFilter;
      //       for (let index = 0; index < that.filteredsNews.length; index++) {
      //         that.optionsNews[index] = [];
      //         that.optionsNews[index].push({
      //           item: that.filteredsNews[index].c_id,
      //           name: "",
      //         });
      //       }
      //     }

      //     itsFinal++;
      //   });
      //   if (this.validateNews == true) {
      //     // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
      //     //   return o.c_u_Status != 8;
      //     // });
      //     const predicate = (start, end) => ({ c_u_Status }) =>
      //   c_u_Status != start && c_u_Status != end;

      //   this.filteredsNews = this.filteredsNews.filter(predicate(8,10));
      //   } else {
      //     this.filteredsNews = this.dataFromFilter;
      //   }
      // }
    },
    async clickedScrolll() {
      if (this.isFilteredData == false && this.filteredText == "") {
        let itsFinal = 0;
        let that = this;
        let newDataOfNews = [];
        that.$api.data.endpoint = `News/scrollDown/${that.sourceIdForScroll}/${that.neededArrayOfNews.length}`;
        newDataOfNews = await that.$api.data.find();
        if (newDataOfNews.length == 0) {
          this.$bvToast.toast("Não existem mais registos", {
            autoHideDelay: 4000,
            variant: "danger",
          });
        }
        for (let index = 0; index < newDataOfNews.length; index++) {
          that.neededArrayOfNews.push(newDataOfNews[index]);
        }
        //debugger;
        that.filteredsNews = that.neededArrayOfNews;
        for (let index = 0; index < that.filteredsNews.length; index++) {
          that.optionsNews[index] = [];
          that.optionsNews[index].push({
            item: that.filteredsNews[index].c_id,
            name: "",
          });
        }

        if (this.validateNews == true) {
          // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
          //   return o.c_u_Status != 8;
          // });
          const predicate = (start, end) => ({ c_u_Status }) =>
            c_u_Status != start && c_u_Status != end;

          this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
        } else {
          this.filteredsNews = this.neededArrayOfNews;
        }
      }
      if (this.isFilteredData == true) {
        let that = this;
        if (
          that.filtersDates.startDate != "" &&
          that.filtersDates.endDate == ""
        ) {
          let todaysDate = new Date();
          todaysDate =
            todaysDate.getFullYear() +
            "-" +
            (todaysDate.getMonth() + 1 < 10
              ? "0" + (todaysDate.getMonth() + 1)
              : todaysDate.getMonth() + 1) +
            "-" +
            (todaysDate.getDate() < 10
              ? "0" + todaysDate.getDate()
              : todaysDate.getDate());
          that.filtersDates.endDate = todaysDate;
        }
        let urlEncoderSource =
          that.selectedFilterSource.length != 0
            ? encodeURIComponent(that.selectedFilterSource.toString())
            : 0;
        let startDateFilter =
          that.filtersDates.startDate == "" ? 0 : that.filtersDates.startDate;
        let endDateFilter =
          that.filtersDates.endDate == "" ? 0 : that.filtersDates.endDate;
        let statusFilter =
          typeof that.selectedFilterStatus != "number"
            ? 0
            : that.selectedFilterStatus;
        let typeFilter =
          typeof that.selectedFilterType != "number"
            ? 20
            : that.selectedFilterType;
        let themeFilter =
          typeof that.selectedFilterTheme != "number"
            ? 0
            : that.selectedFilterTheme;
        let userFilter =
          typeof that.selectedFilterUsers != "number"
            ? 0
            : that.selectedFilterUsers;
        let textFilter = that.filteredText == "" ? 0 : that.filteredText;

        //Call the endpoint of filter
        that.$api.data.endpoint = `${that.endpointNews}/${that.endpointFilteredSection}/${urlEncoderSource}/${typeFilter}/${themeFilter}/${startDateFilter}/${endDateFilter}/${statusFilter}/${userFilter}/${textFilter}/${that.dataFromFilter.length}`;
        let news = await that.$api.data.find();
        for (let index = 0; index < news.length; index++) {
          that.dataFromFilter.push(news[index]);
        }
        //debugger;
        that.filteredsNews = that.dataFromFilter;
        for (let index = 0; index < that.filteredsNews.length; index++) {
          that.optionsNews[index] = [];
          that.optionsNews[index].push({
            item: that.filteredsNews[index].c_id,
            name: "",
          });
        }

        if (this.validateNews == true) {
          // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
          //   return o.c_u_Status != 8;
          // });
          const predicate = (start, end) => ({ c_u_Status }) =>
            c_u_Status != start && c_u_Status != end;

          this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
        } else {
          this.filteredsNews = this.dataFromFilter;
        }
      }
    },
    async clickedEvent(index, referenceSource) {
      if (!this.isNotCreatedNew) {
        this.cancelCreationOfNew();
      }

      let sourceName = document.getElementsByClassName("section1Name");
      if (referenceSource.trim().length == 0) {
        return;
      }
      if (sourceName[index].style.color == "") {
        this.isNotCreatedNew = true;
        this.isFilteredData = false;
        this.filteredsNews = [];
        this.clickedEventSourceId = index;
        this.clickedEventSourceName = referenceSource;
        this.selectedThematics = [];
        this.$api.data.endpoint = this.endpointSources;
        let sourceFindById = _.find(
          await this.$api.data.find(),
          function (filter) {
            return filter.c_u_ReferenceSource == referenceSource;
          }
        );
        for (let i = 0; i < sourceName.length; i++) {
          if (sourceName[i].style.color != "") {
            sourceName[i].style.color = null;
            sourceName[i].style.fontWeight = null;
          }
        }
        sourceName[index].style.color = "#428bac";
        sourceName[index].style.fontWeight = "900";

        this.sourceIdForScroll = sourceFindById.c_id;
        this.$api.data.endpoint = `${this.endpointNewsBySource}/${sourceFindById.c_id}`;
        this.filteredsNews = await this.$api.data.find();

        //console.log(this.filteredsNews);

        // order the news by the date
        this.filteredsNews = this.filteredsNews.sort(
          (a, b) =>
            Date.parse(b.c_u_ProcessedDate) - Date.parse(a.c_u_ProcessedDate)
        );

        //debugger;
        this.neededArrayOfNews = this.filteredsNews;
        if (this.validateNews == true) {
          // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
          //   return o.c_u_Status != 8;
          // });
          const predicate = (start, end) => ({ c_u_Status }) =>
            c_u_Status != start && c_u_Status != end;

          this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
        } else {
          this.filteredsNews = this.neededArrayOfNews;
        }
        this.optionsNews = [[]];
        for (let index = 0; index < this.filteredsNews.length; index++) {
          this.optionsNews[index] = [];
          this.optionsNews[index].push({
            item: this.filteredsNews[index].c_id,
            name: "",
          });
        }
      } else {
        if (this.isNotCreatedNew == true) {
          document.getElementsByClassName("section2Div")[0].style.display = "";
          document.getElementsByClassName("section3Div")[0].style.display = "";
          document.getElementsByClassName("section4Div")[0].style.display = "";
          document.getElementsByClassName(
            "newsCreationContainer"
          )[0].style.display = "none";
          sourceName[index].style.color = "";
          sourceName[index].style.fontWeight = "";
          this.filteredsNews = [];
        } else {
          document.getElementsByClassName("section2Div")[0].style.display = "";
          document.getElementsByClassName("section3Div")[0].style.display = "";
          document.getElementsByClassName("section4Div")[0].style.display = "";
          document.getElementsByClassName(
            "newsCreationContainer"
          )[0].style.display = "none";
          this.isNotCreatedNew = true;
          this.isHidden = false;
        }
      }
    },
    async refreshNews() {
      this.filteredsNews = [];
      this.$api.data.endpoint = `${this.endpointNewsBySource}/${this.sourceIdForScroll}`;
      this.filteredsNews = await this.$api.data.find();
      this.neededArrayOfNews = this.filteredsNews;
      if (this.validateNews == true) {
        // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
        //   return o.c_u_Status != 8;
        // });
        const predicate = (start, end) => ({ c_u_Status }) =>
          c_u_Status != start && c_u_Status != end;

        this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
      } else {
        this.filteredsNews = this.neededArrayOfNews;
      }
    },
    async createNewsInfo() {
      this.selectedThematics = [];
      // this.thematicItems = [];
      this.journalists = [];
      this.Vave = [];
      // this.itemsThemeWords = [];
      this.isNotCreatedNew = false;
      document.getElementsByClassName("section2Div")[0].style.display = "none";
      document.getElementsByClassName("section3Div")[0].style.display = "none";
      document.getElementsByClassName("section4Div")[0].style.display = "none";
      document.getElementsByClassName(
        "newsCreationContainer"
      )[0].style.display = "block";

      try { this.postImageData = null; } catch(err) { }
      try { this.mediaPath = null; } catch(err) { }
      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
      document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
      document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
      document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
      document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
      document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
      document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

      this.$api.data.endpoint = "ThemeWords";
      this.themeWordsToFind = await this.$api.data.find();
      _.remove(this.themeWordsToFind, function (o) {
        return o.c_u_Words == "";
      });
      this.themeProhibitedWordsToFind = await this.$api.data.find();
      _.remove(this.themeProhibitedWordsToFind, function (o) {
        return o.c_u_ProhibitedWords == "";
      });

      //show the sources
      this.$api.data.endpoint = this.endpointSources;
      let listOfSources = await this.$api.data.find();

      for (let index = 0; index < listOfSources.length; index++) {
        Vue.set(this.optionsSourceForCreate, index, {
          item: listOfSources[index].c_u_ReferenceSource,
          code: listOfSources[index].c_id,
        });
      }

      //receive the list of journalists
      this.$api.data.endpoint = this.endpointJournalist;
      this.journalists = await this.$api.data.find();
      for (let index = 0; index < this.journalists.length; index++) {
        Vue.set(this.optionsJournalists, index, {
          id: this.journalists[index].c_id,
          name: this.journalists[index].c_u_Name,
        });
      }
      //receive the list of themes
      // this.$api.data.endpoint = this.endpointThemes;
      // let themes = await this.$api.data.find();
      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        Vue.set(this.thematicItems, index, {
          id: this.itemsThemeWords[index].c_u_ThemeId,
          wordName: this.itemsThemeWords[index].wordName,
          words: this.itemsThemeWords[index].c_u_Words
        });
      }
      this.newThematicItems = this.thematicItems;

      //set newsDate and newsTime
      this.setInterfaceNewsDateTime(moment().format("YYYY-MM-DDTHH:mm:ss.SSS"));
    },
    findThematics() {
      if (this.contentOfCreatedNew != "") {
        let validateString = [];
        let unvalidateString = [];
        let toSelectThematicItems = [];
        let unselectThematicItems = [];

        for (let index = 0; index < this.themeWordsToFind.length; index++) {
          let string = this.themeWordsToFind[index].c_u_Words.split(";");
          validateString.push({
            string: string,
            id: this.themeWordsToFind[index].c_u_ThemeId,
          });
        }
        for (let index = 0; index < this.themeProhibitedWordsToFind.length; index++) {
          let string = this.themeProhibitedWordsToFind[index].c_u_ProhibitedWords.split(";");
          unvalidateString.push({
            string: string,
            id: this.themeProhibitedWordsToFind[index].c_u_ThemeId,
          });
        }
        for (let index = 0; index < unvalidateString.length; index++) {
          for (let i = 0; i < unvalidateString[index].string.length; i++) {
            if (
              unvalidateString[index].string[i].length != 0 &&
              unvalidateString[index].string[i].length != 1
            ) {
              //SIGLAS find
              if (
                unvalidateString[index].string[i].trim() ==
                unvalidateString[index].string[i].trim().toUpperCase()
              ) {
                if (
                  new RegExp(
                    "\\b" + `${unvalidateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew)
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == unvalidateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!unselectThematicItems.includes(thematic)) {
                      unselectThematicItems.push(thematic);
                    }
                  }
                }
              } else {
                if (
                  new RegExp(
                    "\\b" + `${unvalidateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew) ||
                  new RegExp(
                    "\\b" +
                      `${unvalidateString[index].string[i]
                        .trim()
                        .toLowerCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toLowerCase()) ||
                  new RegExp(
                    "\\b" +
                      `${unvalidateString[index].string[i]
                        .trim()
                        .toUpperCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toUpperCase())
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == unvalidateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!unselectThematicItems.includes(thematic)) {
                      unselectThematicItems.push(thematic);
                    }
                  }
                }
              }
            }
          }
        }
        for (let index = 0; index < validateString.length; index++) {
          for (let i = 0; i < validateString[index].string.length; i++) {
            if (
              validateString[index].string[i].length != 0 &&
              validateString[index].string[i].length != 1
            ) {
              //SIGLAS find
              if (
                validateString[index].string[i].trim() ==
                validateString[index].string[i].trim().toUpperCase()
              ) {
                if (
                  new RegExp(
                    "\\b" + `${validateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew)
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == validateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!toSelectThematicItems.includes(thematic)) {
                      toSelectThematicItems.push(thematic);
                    }
                  }
                }
              } else {
                if (
                  new RegExp(
                    "\\b" + `${validateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew) ||
                  new RegExp(
                    "\\b" +
                      `${validateString[index].string[i]
                        .trim()
                        .toLowerCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toLowerCase()) ||
                  new RegExp(
                    "\\b" +
                      `${validateString[index].string[i]
                        .trim()
                        .toUpperCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toUpperCase())
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == validateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!toSelectThematicItems.includes(thematic)) {
                      toSelectThematicItems.push(thematic);
                    }
                  }
                }
              }
            }
          }
        }
        for (let index = 0; index < this.thematicItems.length; index++) {
          if (
            this.thematicItems[index].wordName ==
            this.thematicItems[index].wordName.toUpperCase()
          ) {
            if (
              new RegExp(
                "\\b" + `${this.thematicItems[index].wordName}` + "\\b"
              ).test(this.contentOfCreatedNew)
            ) {
              if (!toSelectThematicItems.includes(this.thematicItems[index])) {
                toSelectThematicItems.push(this.thematicItems[index]);
              }
            }
          } else {
            if (
              new RegExp(
                "\\b" + `${this.thematicItems[index].wordName}` + "\\b"
              ).test(this.contentOfCreatedNew) ||
              new RegExp(
                "\\b" +
                  `${this.thematicItems[index].wordName.toLowerCase()}` +
                  "\\b"
              ).test(this.contentOfCreatedNew.toLowerCase()) ||
              new RegExp(
                "\\b" +
                  `${this.thematicItems[index].wordName.toUpperCase()}` +
                  "\\b"
              ).test(this.contentOfCreatedNew.toUpperCase())
            ) {
              if (!toSelectThematicItems.includes(this.thematicItems[index])) {
                toSelectThematicItems.push(this.thematicItems[index]);
              }
            }
          }
        }
        toSelectThematicItems = toSelectThematicItems.filter(a => {
          return !unselectThematicItems.some(b => b.id === a.id);
        });
        this.selectedThematics = toSelectThematicItems;
        //console.log("this.thematicItems: ", this.thematicItems);
        //debugger;
      } else {
        this.$bvToast.toast(
          "Necessário preencher o Conteúdo para poder efetuar reconhecimento de temáticas",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      }
    },
    findThematics2() {
      //console.log("this.newsArray.c_u_Content: ", this.newsArray.c_u_Content);
      //debugger;
      if (this.newsArray.c_u_Content != "") {
        //console.log("validateString: ", validateString);
        //debugger;
        for (let index = 0; index < this.thematicItems.length; index++) {
        }
      }
      
      if (this.newsArray.c_u_Content != "") {
        let validateString = [];
        let unvalidateString = [];
        let toSelectThematicItems = [];
        let unselectThematicItems = [];

        for (let index = 0; index < this.themeWordsToFind.length; index++) {
          let string = this.themeWordsToFind[index].c_u_Words.split(";");
          validateString.push({
            string: string,
            id: this.themeWordsToFind[index].c_u_ThemeId,
          });
        }
        for (let index = 0; index < this.themeProhibitedWordsToFind.length; index++) {
          let string = this.themeProhibitedWordsToFind[index].c_u_ProhibitedWords.split(";");
          unvalidateString.push({
            string: string,
            id: this.themeProhibitedWordsToFind[index].c_u_ThemeId,
          });
        }
        for (let index = 0; index < unvalidateString.length; index++) {
          for (let i = 0; i < unvalidateString[index].string.length; i++) {
            if (
              unvalidateString[index].string[i].length != 0 &&
              unvalidateString[index].string[i].length != 1
            ) {
              //SIGLAS find
              if (
                unvalidateString[index].string[i].trim() ==
                unvalidateString[index].string[i].trim().toUpperCase()
              ) {
                if (
                  new RegExp(
                    "\\b" + `${unvalidateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew)
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == unvalidateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!unselectThematicItems.includes(thematic)) {
                      unselectThematicItems.push(thematic);
                    }
                  }
                }
              } else {
                if (
                  new RegExp(
                    "\\b" + `${unvalidateString[index].string[i].trim()}` + "\\b"
                  ).test(this.contentOfCreatedNew) ||
                  new RegExp(
                    "\\b" +
                      `${unvalidateString[index].string[i]
                        .trim()
                        .toLowerCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toLowerCase()) ||
                  new RegExp(
                    "\\b" +
                      `${unvalidateString[index].string[i]
                        .trim()
                        .toUpperCase()}` +
                      "\\b"
                  ).test(this.contentOfCreatedNew.toUpperCase())
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == unvalidateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!unselectThematicItems.includes(thematic)) {
                      unselectThematicItems.push(thematic);
                    }
                  }
                }
              }
            }
          }
        }
        for (let index = 0; index < validateString.length; index++) {
          for (let i = 0; i < validateString[index].string.length; i++) {
            if (
              validateString[index].string[i].length != 0 &&
              validateString[index].string[i].length != 1
            ) {
              //SIGLAS find
              if (
                validateString[index].string[i].trim() ==
                validateString[index].string[i].trim().toUpperCase()
              ) {
                if (
                  new RegExp(
                    "\\b" + `${validateString[index].string[i].trim()}` + "\\b"
                  ).test(this.newsArray.c_u_Content)
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == validateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!toSelectThematicItems.includes(thematic)) {
                      toSelectThematicItems.push(thematic);
                    }
                  }
                }
              } else {
                if (
                  new RegExp(
                    "\\b" + `${validateString[index].string[i].trim()}` + "\\b"
                  ).test(this.newsArray.c_u_Content) ||
                  new RegExp(
                    "\\b" +
                      `${validateString[index].string[i]
                        .trim()
                        .toLowerCase()}` +
                      "\\b"
                  ).test(this.newsArray.c_u_Content.toLowerCase()) ||
                  new RegExp(
                    "\\b" +
                      `${validateString[index].string[i]
                        .trim()
                        .toUpperCase()}` +
                      "\\b"
                  ).test(this.newsArray.c_u_Content.toUpperCase())
                ) {
                  let thematic = _.find(this.thematicItems, function (o) {
                    return o.id == validateString[index].id;
                  });
                  if (thematic != undefined) {
                    if (!toSelectThematicItems.includes(thematic)) {
                      toSelectThematicItems.push(thematic);
                    }
                  }
                }
              }
            }
          }
        }
        for (let index = 0; index < this.thematicItems.length; index++) {
          var Thematic = this.thematicItems[index];
          var Words = Thematic.words.split(";");
          for (var index2 = 0; index2 < Words.length; index2++) {
            var Word = Words[index2];
            try {
              var WordProcessed = Word.trim();
              if (WordProcessed.length > 0) {
                var HasMatch = false;
                if (WordProcessed.length <= 3) {
                  //title
                  HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(this.newsArray.c_u_Title);
                  //summary
                  if (!HasMatch) {
                    HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(this.newsArray.c_u_Summary);
                  }
                  //body
                  if (!HasMatch) {
                    HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(this.newsArray.c_u_Content);
                  }
                }
                else {
                  //title
                  HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(this.newsArray.c_u_Title.toLowerCase());
                  //summary
                  if (!HasMatch) {
                    HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(this.newsArray.c_u_Summary.toLowerCase());
                  }
                  //body
                  if (!HasMatch) {
                    HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(this.newsArray.c_u_Content.toLowerCase());
                  }
                }
                if (HasMatch) {
                  if (!toSelectThematicItems.includes(this.thematicItems[index])) {
                    toSelectThematicItems.push(this.thematicItems[index]);
                  }
                  break;
                }
              }
            }
            catch(err) {}
          }
        }
        toSelectThematicItems = toSelectThematicItems.filter(a => {
          return !unselectThematicItems.some(b => b.id === a.id);
        });
        this.selectedThematics = toSelectThematicItems;

        //console.log("this.thematicItems: ", this.thematicItems);
        //debugger;
      } else {
        this.$bvToast.toast(
          "Necessário preencher o Conteúdo para poder efetuar reconhecimento de temáticas",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      }
    },
    rememberCreateObject(item) {
      this.createdNew.c_r_Source = this.sourceOfCreatedNew;
      this.createdNew.c_u_NewsOriginType = item.c_u_NewsOriginType;
      this.createdNew.c_u_News_MMS_ProgramName = item.c_u_News_MMS_ProgramName;
      this.savedCreatedNew = this.createdNew;
    },
    loadCreateObject() {
      this.sourceOfCreatedNew = this.savedCreatedNew.c_r_Source;
      //this.contentOfCreatedNew = this.savedCreatedNew.c_u_Content;
      this.createdNew.c_u_NewsOriginType = this.savedCreatedNew.c_u_NewsOriginType;
      this.createdNew.c_u_News_MMS_ProgramName = this.savedCreatedNew.c_u_News_MMS_ProgramName;
      //this.createdNew = this.savedCreatedNew;
      this.$forceUpdate();
    },
    cancelCreationOfNew() {
      this.isNotCreatedNew = true;
      this.isHidden = false;
      document.getElementsByClassName("section2Div")[0].style.display = "";
      document.getElementsByClassName("section3Div")[0].style.display = "";
      document.getElementsByClassName("section4Div")[0].style.display = "";
      document.getElementsByClassName(
        "newsCreationContainer"
      )[0].style.display = "none";
      this.selectedThematics = [];
      //clear all data after its created
      this.sourceOfCreatedNew = 0;
      this.contentOfCreatedNew = "";
      this.createdNew = {
        c_r_Journalist: null,
        c_u_ProcessedDate: "",
        c_u_NumberOfGetTries: 0,
        c_u_NumberOfExtractTries: 0,
        c_u_RawNews: "",
        c_u_ExtractionMethod: "0,0,0,0",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_UrlNews: "",
        c_r_Source: 0,
        c_u_Content: "",
        c_u_ExternalID: 0,
        c_u_ExtractionMethod: "",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_Image: "",
        c_u_Keywords: "",
        c_u_NewsAVE: 0,
        c_u_NewsCreateByUser: null,
        c_u_NewsDateCreate: "",
        c_u_NewsFilePath: null,
        c_u_NewsOriginType: 0,
        c_u_News_MMS_ProgramName: "",
        c_u_NewsThumbnail: "",
        c_u_NewsidxFav: null,
        c_u_ProcessedDate: "",
        c_u_Status: 5,
        c_u_Summary: "",
        c_u_Title: "",
        c_u_Type: 0,
        c_u_isHighlighted: false,
        c_u_NewsPageNumber: null
      };
    },
    async postCreateNew(item) {
      if (this.sourceOfCreatedNew == 0) {
        this.$bvToast.toast(
          "Para efetuar a criação da noticia é necessario preencher a fonte",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      } else {
        item.c_r_Source = this.sourceOfCreatedNew;
        item.c_u_NewsCreateByUser = this.getLoggedInUserID();
        item.c_u_Summary =
          item.c_u_Summary != ""
            ? item.c_u_Summary.replace(/<[^>]*>?/gm, "")
            : item.c_u_Summary;
        item.c_u_Content = this.contentOfCreatedNew;

        //console.log("item.c_r_Journalist before", item.c_r_Journalist);
        // check if we have the journalist in the list
        if (item.c_r_Journalist != null) {
          if (typeof item.c_r_Journalist.name == "string") {
            this.$api.data.endpoint = this.endpointJournalist;
            let checkIdJournalist = _.find(
              await this.$api.data.find(),
              function (journalist) {
                return journalist.c_u_Name == item.c_r_Journalist.name;
              }
            );
            item.c_r_Journalist = checkIdJournalist.c_id;
          } else {
            item.c_r_Journalist = item.c_r_Journalist;
          }
        }
        //console.log("item.c_r_Journalist after", item.c_r_Journalist);

        let d = new Date();
        let mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let yy = d.getFullYear();
        item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
        item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

        //news create date and time
        if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
          item.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
        }

        if (
          item.c_u_Title == "" ||
          item.c_u_Content == "" ||
          item.c_u_Summary == ""
        ) {
          item.c_u_Status = 11;//what is this state?
        } else {
          item.c_u_Status = 6;
          item.c_u_NewsEditByUser = this.getLoggedInUserID();
          item.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
        }

        let createdImageFile = this.postImageData;
        let createdMediaFile = this.mediaPath;
        let previewImage = document.getElementById("output");
        let that = this;
        let urlMedia = this.getUrl;

        //old way - CORS errors
        /*$.ajax({
          type: "POST",
          contentType: "application/json; charset=utf-8",
          cache: false,
          url: `${this.getUrl}/api/News`,
          data: JSON.stringify(item),
          xhrFields: {
            withCredentials: true
          },
          success: async function (data) {
            that.idOfCreatedNew = data.c_id;
            if (previewImage.src != "") {
              $.ajax({
                url: `${urlMedia}/api/Image/${data.c_id}`,
                data: createdImageFile,
                processData: false,
                contentType: false,
                type: "PATCH",
                xhrFields: {
                  withCredentials: true
                },
              });
            }
            $.ajax({
              url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
              data: createdMediaFile,
              processData: false,
              contentType: false,
              type: "PATCH",
              xhrFields: {
                withCredentials: true
              },
            });
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR.responseText);
          },
          dataType: "json",
        });*/

        //new way - to avoid CORS errors
        this.$api.data.endpoint = this.endpointNews;
        var NewsResult = await this.$api.data.create2(item);
        //console.log("NewsResult", NewsResult);
        var NewsID = 0;
        try {
          if (NewsResult.c_id > 0) {
            NewsID = NewsResult.c_id;
          }
        } catch (err) {}
        if (NewsID > 0) {
          that.idOfCreatedNew = NewsID;
          if (previewImage.src != "") {
            this.$api.data.endpoint = "Image";
            var ImageResult = await this.$api.data.uploadImageById(
              NewsResult.c_id,
              createdImageFile
            );
            //console.log("ImageResult", ImageResult);
          }
          this.$api.data.endpoint = "Image/VideoAudio";
          var VideoAudioResult = await this.$api.data.uploadImageById(
            NewsResult.c_id,
            createdMediaFile
          );
          //console.log("VideoAudioResult", VideoAudioResult);
        }

        if (NewsID > 0) {
          //process base64 images after other media uploads
          this.$api.data.endpoint = "News/PostSaveProcessBase64";
          var Payload = { NewsID: NewsID, UserID: this.getLoggedInUserID() };
          try {
            await this.$api.data.update(Payload);
          } catch (err) {}
        }

        if (NewsID > 0) {
          this.$bvToast.toast("Noticia criada com sucesso", {
            autoHideDelay: 4000,
            variant: "success",
          });
        } else {
          this.$bvToast.toast("Não foi possível criar a notícia", {
            autoHideDelay: 4000,
            variant: "danger",
          });
        }
      }
    },
    async publishCreateNew(item) {
      item.c_r_Source = this.sourceOfCreatedNew;
      item.c_u_NewsCreateByUser = this.getLoggedInUserID();
      item.c_u_Summary =
        item.c_u_Summary != ""
          ? item.c_u_Summary.replace(/<[^>]*>?/gm, "")
          : item.c_u_Summary;
      item.c_u_Content = this.contentOfCreatedNew;

      //console.log("item.c_r_Journalist before", item.c_r_Journalist);
      // check if we have the journalist in the list
      if (item.c_r_Journalist != null) {
        if (typeof item.c_r_Journalist.name == "string") {
          this.$api.data.endpoint = this.endpointJournalist;
          let checkIdJournalist = _.find(
            await this.$api.data.find(),
            function (journalist) {
              return journalist.c_u_Name == item.c_r_Journalist.name;
            }
          );
          item.c_r_Journalist = checkIdJournalist.c_id;
        } else {
          item.c_r_Journalist = item.c_r_Journalist;
        }
      }
      //console.log("item.c_r_Journalist after", item.c_r_Journalist);

      let d = new Date();
      let mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let yy = d.getFullYear();
      item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
      item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

      //news create date and time
      if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
        item.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
      }

      if (
        item.c_u_Title == "" ||
        item.c_u_Content == "" ||
        item.c_u_Summary == ""
      ) {
        this.$bvToast.toast(
          "Para efetuar a publicação é necessario preencher o titulo, resumo e o Conteúdo",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      } else {
        item.c_u_Status = 8;
        item.c_u_NewsPublishedByUser = this.getLoggedInUserID();
        let createdImageFile = this.postImageData;
        let createdMediaFile = this.mediaPath;
        let previewImage = document.getElementById("output");
        let that = this;
        let urlMedia = this.getUrl;

        //old way - CORS errors
        /*$.ajax({
          type: "POST",
          contentType: "application/json; charset=utf-8",
          cache: false,
          url: `${this.getUrl}/api/News`,
          data: JSON.stringify(item),
          success: async function (data) {
            that.idOfCreatedNew = data.c_id;
            if (previewImage.src != "") {
              $.ajax({
                url: `${urlMedia}/api/Image/${data.c_id}`,
                data: createdImageFile,
                processData: false,
                contentType: false,
                type: "PATCH",
              });
              $.ajax({
                url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
                data: createdMediaFile,
                processData: false,
                contentType: false,
                type: "PATCH",
              });
            }
          },
          dataType: "json",
        });*/

        //new way - to avoid CORS errors
        this.$api.data.endpoint = this.endpointNews;
        var NewsResult = await this.$api.data.create2(item);
        //console.log("NewsResult", NewsResult);
        var NewsID = 0;
        try {
          if (NewsResult.c_id > 0) {
            NewsID = NewsResult.c_id;
          }
        } catch (err) {}
        if (NewsID > 0) {
          that.idOfCreatedNew = NewsID;
          if (previewImage.src != "") {
            this.$api.data.endpoint = "Image";
            var ImageResult = await this.$api.data.uploadImageById(
              NewsResult.c_id,
              createdImageFile
            );
            //console.log("ImageResult", ImageResult);
          }
          this.$api.data.endpoint = "Image/VideoAudio";
          var VideoAudioResult = await this.$api.data.uploadImageById(
            NewsResult.c_id,
            createdMediaFile
          );
          //console.log("VideoAudioResult", VideoAudioResult);
        }

        if (NewsID > 0) {
          //process base64 images after other media uploads
          this.$api.data.endpoint = "News/PostSaveProcessBase64";
          var Payload = { NewsID: NewsID, UserID: this.getLoggedInUserID() };
          try {
            await this.$api.data.update(Payload);
          } catch (err) {}
        }

        if (NewsID > 0) {
          this.$bvToast.toast("Noticia criada e publicada com sucesso", {
            autoHideDelay: 4000,
            variant: "success",
          });
        } else {
          this.$bvToast.toast("Não foi possível criar ou publicar a notícia", {
            autoHideDelay: 4000,
            variant: "danger",
          });
        }
      }
    },
    async copyCreateNew(item) {
      item.c_r_Source = this.sourceOfCreatedNew;
      item.c_u_NewsCreateByUser = this.getLoggedInUserID();
      item.c_u_Summary =
        item.c_u_Summary != ""
          ? item.c_u_Summary.replace(/<[^>]*>?/gm, "")
          : item.c_u_Summary;
      item.c_u_Content = this.contentOfCreatedNew;

      //console.log("item.c_r_Journalist before", item.c_r_Journalist);
      // check if we have the journalist in the list
      if (item.c_r_Journalist != null) {
        if (typeof item.c_r_Journalist.name == "string") {
          this.$api.data.endpoint = this.endpointJournalist;
          let checkIdJournalist = _.find(
            await this.$api.data.find(),
            function (journalist) {
              return journalist.c_u_Name == item.c_r_Journalist.name;
            }
          );
          item.c_r_Journalist = checkIdJournalist.c_id;
        } else {
          item.c_r_Journalist = item.c_r_Journalist;
        }
      }
      //console.log("item.c_r_Journalist after", item.c_r_Journalist);

      let d = new Date();
      let mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let yy = d.getFullYear();
      item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
      item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

      //news create date and time
      if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
        item.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
      }

      if (
        item.c_u_Title == "" ||
        item.c_u_Content == "" ||
        item.c_u_Summary == ""
      ) {
        this.$bvToast.toast(
          "Para efetuar a publicação é necessario preencher o titulo, resumo e o Conteúdo",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      } else {
        item.c_u_Status = 7;
        let createdImageFile = this.postImageData;
        let createdMediaFile = this.mediaPath;
        let previewImage = document.getElementById("output");
        let that = this;
        let urlMedia = this.getUrl;

        //old way - CORS errors
        /*$.ajax({
          type: "POST",
          contentType: "application/json; charset=utf-8",
          cache: false,
          url: `${this.getUrl}/api/News`,
          data: JSON.stringify(item),
          success: async function (data) {
            that.idOfCreatedNew = data.c_id;
            if (previewImage.src != "") {
              $.ajax({
                url: `${urlMedia}/api/Image/${data.c_id}`,
                data: createdImageFile,
                processData: false,
                contentType: false,
                type: "PATCH",
              });
              $.ajax({
                url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
                data: createdMediaFile,
                processData: false,
                contentType: false,
                type: "PATCH",
              });
            }
          },
          dataType: "json",
        });
        this.$bvToast.toast("Noticia criada e copiada com sucesso", {
          autoHideDelay: 4000,
          variant: "success",
        });*/

        //new way - to avoid CORS errors
        this.$api.data.endpoint = this.endpointNews;
        var NewsResult = await this.$api.data.create2(item);
        //console.log("NewsResult", NewsResult);
        var NewsID = 0;
        try {
          if (NewsResult.c_id > 0) {
            NewsID = NewsResult.c_id;
          }
        } catch (err) {}
        if (NewsID > 0) {
          that.idOfCreatedNew = NewsID;
          if (previewImage.src != "") {
            this.$api.data.endpoint = "Image";
            var ImageResult = await this.$api.data.uploadImageById(
              NewsResult.c_id,
              createdImageFile
            );
            //console.log("ImageResult", ImageResult);
          }
          this.$api.data.endpoint = "Image/VideoAudio";
          var VideoAudioResult = await this.$api.data.uploadImageById(
            NewsResult.c_id,
            createdMediaFile
          );
          //console.log("VideoAudioResult", VideoAudioResult);
        }

        if (NewsID > 0) {
          //process base64 images after other media uploads
          this.$api.data.endpoint = "News/PostSaveProcessBase64";
          var Payload = { NewsID: NewsID, UserID: this.getLoggedInUserID() };
          try {
            await this.$api.data.update(Payload);
          } catch (err) {}
        }

        if (NewsID > 0) {
          this.$bvToast.toast("Noticia criada e copiada com sucesso", {
            autoHideDelay: 4000,
            variant: "success",
          });
        } else {
          this.$bvToast.toast("Não foi possível criar ou copiar a notícia", {
            autoHideDelay: 4000,
            variant: "danger",
          });
        }
      }
    },
    async editNews(newsid, news) {
      this.Vave = [];
      this.optionsAve = [];

      this.neededId = newsid;
      this.neededNews = news;

      try { this.postImageData = null; } catch(err) { }
      try { this.mediaPath = null; } catch(err) { }
      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
      document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
      document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
      document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
      document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
      document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
      document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

      this.isHidden = true;
      this.selectedThematics = [];
      this.$api.data.endpoint = this.endpointNews;
      
      this.newsArray = await this.$api.data.findOneById(news.c_id);

      if (this.newsArray.c_u_NewsEditByUser != null) {
        this.$api.data.endpoint = this.endpointUsers;
        let user = await this.$api.data.findOneById(
          this.newsArray.c_u_NewsEditByUser
        );
        this.getUserInfoEdit = user[0].User.DisplayName;
        this.getFormatedNewsEditedDate = new Date(
          this.newsArray.c_u_NewsDateEdit
        );

        this.getFormatedNewsEditedDate =
          (this.getFormatedNewsEditedDate.getDate() < 10
            ? "0" + this.getFormatedNewsEditedDate.getDate()
            : this.getFormatedNewsEditedDate.getDate()) +
          "-" +
          (this.getFormatedNewsEditedDate.getMonth() + 1 < 10
            ? "0" + (this.getFormatedNewsEditedDate.getMonth() + 1)
            : this.getFormatedNewsEditedDate.getMonth() + 1) +
          "-" +
          this.getFormatedNewsEditedDate.getFullYear() +
          " às " +
          (this.getFormatedNewsEditedDate.getHours() < 10
            ? "0" + (this.getFormatedNewsEditedDate.getHours())
            : this.getFormatedNewsEditedDate.getHours()) +
          ":" +
          (this.getFormatedNewsEditedDate.getMinutes() < 10
            ? "0" + this.getFormatedNewsEditedDate.getMinutes()
            : this.getFormatedNewsEditedDate.getMinutes());
      }
      //Show information of the user that published the new
      if (this.newsArray.c_u_NewsPublishedByUser != null) {
        if (this.newsArray.c_u_NewsPublishedByUser != 0) {
          this.$api.data.endpoint = this.endpointUsers;
          let user = await this.$api.data.findOneById(
            this.newsArray.c_u_NewsPublishedByUser
          );
          this.getUserInfoPublish = user[0].User.DisplayName;
          this.getFormatedNewsPublishedDate = new Date(
            this.newsArray.c_u_NewsDatePublished
          );

          this.getFormatedNewsPublishedDate =
            (this.getFormatedNewsPublishedDate.getDate() < 10
              ? "0" + this.getFormatedNewsPublishedDate.getDate()
              : this.getFormatedNewsPublishedDate.getDate()) +
            "-" +
            (this.getFormatedNewsPublishedDate.getMonth() + 1 < 10
              ? "0" + (this.getFormatedNewsPublishedDate.getMonth() + 1)
              : this.getFormatedNewsPublishedDate.getMonth() + 1) +
            "-" +
            this.getFormatedNewsPublishedDate.getFullYear() +
            " às " +
            (this.getFormatedNewsPublishedDate.getHours() < 10
              ? "0" + (this.getFormatedNewsPublishedDate.getHours())
              : this.getFormatedNewsPublishedDate.getHours()) +
            ":" +
            (this.getFormatedNewsPublishedDate.getMinutes() < 10
              ? "0" + this.getFormatedNewsPublishedDate.getMinutes()
              : this.getFormatedNewsPublishedDate.getMinutes());
        }
      }
      //show the information of the user that create the new
      if (this.newsArray.c_u_NewsCreateByUser != null) {
        this.$api.data.endpoint = this.endpointUsers;
        let user = await this.$api.data.findOneById(
          this.newsArray.c_u_NewsCreateByUser
        );
        this.getUserInfoCreate = user[0].User.DisplayName;
        this.getFormatedNewsCreatedDate = new Date(
          this.newsArray.c_u_NewsDateCreate
        );

        this.getFormatedNewsCreatedDate =
          (this.getFormatedNewsCreatedDate.getDate() < 10
            ? "0" + this.getFormatedNewsCreatedDate.getDate()
            : this.getFormatedNewsCreatedDate.getDate()) +
          "-" +
          (this.getFormatedNewsCreatedDate.getMonth() + 1 < 10
            ? "0" + (this.getFormatedNewsCreatedDate.getMonth() + 1)
            : this.getFormatedNewsCreatedDate.getMonth() + 1) +
          "-" +
          this.getFormatedNewsCreatedDate.getFullYear() +
          " às " +
          (this.getFormatedNewsCreatedDate.getHours() < 10
            ? "0" + (this.getFormatedNewsCreatedDate.getHours())
            : this.getFormatedNewsCreatedDate.getHours()) +
          ":" +
          (this.getFormatedNewsCreatedDate.getMinutes() < 10
            ? "0" + this.getFormatedNewsCreatedDate.getMinutes()
            : this.getFormatedNewsCreatedDate.getMinutes());
      }

      //set newsDate and newsTime
      this.setInterfaceNewsDateTime(this.newsArray.c_u_NewsDateCreate);

      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";

      if (this.newsArray.c_u_NewsFilePath != null) {
        const audio = document.createElement("audio");
        const video = document.createElement("video");
        audio.src = `${this.newsArray.c_u_NewsFilePath}`;
        video.src = `${this.newsArray.c_u_NewsFilePath}`;
        video.style = "width:300px; height: 200px";
        audio.id = "audioPreview";
        video.id = "videoPreview";
        audio.controls = "true";
        video.controls = "true";
        if (
          this.newsArray.c_u_NewsFilePath.match("ogg") ||
          this.newsArray.c_u_NewsFilePath.match("mp3")
        ) {
          document.getElementById("fileVideoAudio2").appendChild(audio);
        }
        if (this.newsArray.c_u_NewsFilePath.match("mp4")) {
          document.getElementById("fileVideoAudio2").appendChild(video);
        }
      }
      //receive the list of journalists
      this.$api.data.endpoint = this.endpointJournalist;
      this.journalists = await this.$api.data.find();
      for (let index = 0; index < this.journalists.length; index++) {
        Vue.set(this.optionsJournalists, index, {
          id: this.journalists[index].c_id,
          name: this.journalists[index].c_u_Name,
        });
      }

      //receive the list of AVES
      this.$api.data.endpoint = this.endpointAVE;
      this.Vave = await this.$api.data.findOneById(this.newsArray.c_r_Source);
      for (let index = 0; index < this.Vave.length; index++) {
        Vue.set(this.optionsAve, index, {
          id: this.Vave[index].id,
          newAve: this.Vave[index].aveText,
        });
      }

      //receive the list of themes
      // this.$api.data.endpoint = this.endpointThemes;
      // let themes = await this.$api.data.find();
      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        Vue.set(this.thematicItems, index, {
          id: this.itemsThemeWords[index].c_u_ThemeId,
          wordName: this.itemsThemeWords[index].wordName,
          words: this.itemsThemeWords[index].c_u_Words
        });
      }
      this.newThematicItems = this.thematicItems;
      let section =
        document.getElementById("sectionThems") != undefined
          ? document.getElementById("sectionThems").childNodes
          : [];
      for (let index = 0; index < section.length; index++) {
        if (section[index].style.color == "black") {
          section[index].style.color = null;
          section[index].style.backgroundColor = null;
          section[index].style.fontWeight = null;
        }
      }

      //receive the list of join tables themes, themesWord, themesWordNews
      this.$api.data.endpoint = `ThemeWordsNews/Thematics/${this.newsArray.c_id}`;
      let joinedTables = await this.$api.data.find();
      for (let index = 0; index < joinedTables.length; index++) {
        if (joinedTables[index].themeNews == this.newsArray.c_id) {
          this.selectedThematics.push({
            id: joinedTables[index].themeWordId,
            wordName: joinedTables[index].wordName,
            c_id: joinedTables[index].c_id,
          });
        }
      }

      let previewImage = document.getElementById("output");
      //check if we have image from /uploads/ with regex
      var patt = /media/;
      var result = this.newsArray.c_u_Image.match(patt);
      if (result == null) {
        previewImage.src = "";
      } else {
        $("#output").attr("src", `${this.newsArray.c_u_Image}`);
        //previewImage.src = `${this.endpointImages}${this.newsArray.c_u_Image}`;
      }
      document
        .getElementById("AVEdropDown")
        .getElementsByTagName("ul")[0].style.width = "450px";
      document
        .getElementById("journalistDropDown")
        .getElementsByTagName("ul")[0].style.width = "350px";
    },
    async postEditNew(newsArray, data) {
      // update the news
      if (newsArray.c_u_Status > 0 && newsArray.c_u_Status <= 6) {
        newsArray.c_u_Status = 6;
      }
      newsArray.c_u_NewsEditByUser = this.getLoggedInUserID();
      let d = new Date();
      let mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let yy = d.getFullYear();
      newsArray.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
      newsArray.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

      //news create date and time
      if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
        newsArray.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
      }

      newsArray.c_u_Summary =
        newsArray.c_u_Summary != ""
          ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "")
          : newsArray.c_u_Summary;
      //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

      // check if we have the journalist in the list
      if (newsArray.c_r_Journalist != null) {
        if (typeof newsArray.c_r_Journalist.name == "string") {
          this.$api.data.endpoint = this.endpointJournalist;
          let checkIdJournalist = _.find(
            await this.$api.data.find(),
            function (journalist) {
              return journalist.c_u_Name == newsArray.c_r_Journalist.name;
            }
          );
          newsArray.c_r_Journalist = checkIdJournalist.c_id;
        } else {
          newsArray.c_r_Journalist = newsArray.c_r_Journalist;
        }
      }
      this.$api.data.endpoint = this.endpointNews;
      try {
        await this.$api.data.updatedById(newsArray.c_id, newsArray);
      } catch (err) {}

      // create the thematic
      for (let index = 0; index < this.selectedThematics.length; index++) {
        let objectThemesWord = {
          c_u_Words: this.selectedThematics[index].wordName,
          c_u_ThemeId: this.selectedThematics[index].id,
        };
        this.$api.data.endpoint = "ThemeWords";
        let findOneByIdThemes = _.find(
          await this.$api.data.find(),
          function (o) {
            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
          }
        );
        this.$api.data.endpoint = `ThemeWordsNews/Thematics/${newsArray.c_id}`;
        let findThemeNews = _.find(await this.$api.data.find(), function (r) {
          return (
            r.themeNews == newsArray.c_id &&
            r.themeWordId == findOneByIdThemes.c_u_ThemeId
          );
        });
        if (findThemeNews == undefined) {
          this.$api.data.endpoint = "ThemeWordsNews";
          let objectThemes = {
            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
            c_u_Type: 0,
            c_u_Status: 1,
            c_r_ThemeWords: findOneByIdThemes.c_id,
            c_r_News: newsArray.c_id,
          };
          await this.$api.data.create(objectThemes);
        }
      }
      this.selectedThematics = [];
      // upload Image to the server;
      let patt = /media/;
      let previewImage = document.getElementById("output");
      let result = previewImage.src.match(patt);
      if (previewImage.src != "" && result == null) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
          data: this.postImageData,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image";
        var ImageResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.postImageData
        );
      }
      let input = document.getElementById("filesMedia2");
      let files = input.files;
      //debugger;
      if (files.length > 0) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
          data: this.mediaPath,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image/VideoAudio";
        var VideoAudioResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.mediaPath
        );
      }
      for (let index = 0; index < this.filteredsNews.length; index++) {
        if (this.filteredsNews[index].c_id == newsArray.c_id) {
          this.filteredsNews[index].c_u_Status = 6;
        }
      }

      if (newsArray.c_id > 0) {
        //process base64 images after other media uploads
        this.$api.data.endpoint = "News/PostSaveProcessBase64";
        var Payload = { NewsID: newsArray.c_id, UserID: this.getLoggedInUserID() };
        try {
          await this.$api.data.update(Payload);
        } catch (err) {}
      }

      this.isHidden = false;
      // this.$forceUpdate();
      // this.clickedEvent();
      this.imagesUpload(newsArray);
      this.showData();
    },
    async publishEditedNew(newsArray) {
      //newsArray.c_u_NewsDatePublished = new Date();
      newsArray.c_u_NewsPublishedByUser = this.getLoggedInUserID();
      newsArray.c_u_Status = 8;
      newsArray.c_u_Summary =
        newsArray.c_u_Summary != ""
          ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "")
          : newsArray.c_u_Summary;
      //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

      //news create date and time
      if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
        newsArray.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
      }

      // check if we have the journalist in the list
      if (newsArray.c_r_Journalist != null) {
        if (typeof newsArray.c_r_Journalist.name == "string") {
          this.$api.data.endpoint = this.endpointJournalist;
          let checkIdJournalist = _.find(
            await this.$api.data.find(),
            function (journalist) {
              return journalist.c_u_Name == newsArray.c_r_Journalist.name;
            }
          );
          newsArray.c_r_Journalist = checkIdJournalist.c_id;
        } else {
          newsArray.c_r_Journalist = newsArray.c_r_Journalist;
        }
      }
      this.$api.data.endpoint = this.endpointNews;
      try {
        await this.$api.data.updatedById(newsArray.c_id, newsArray);
      } catch (err) {}

      // create the thematic
      for (let index = 0; index < this.selectedThematics.length; index++) {
        let objectThemesWord = {
          c_u_Words: this.selectedThematics[index].wordName,
          c_u_ThemeId: this.selectedThematics[index].id,
        };
        this.$api.data.endpoint = "ThemeWords";
        let findOneByIdThemes = _.find(
          await this.$api.data.find(),
          function (o) {
            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
          }
        );
        this.$api.data.endpoint = `ThemeWordsNews/Thematics/${newsArray.c_id}`;
        let findThemeNews = _.find(await this.$api.data.find(), function (r) {
          return (
            r.themeNews == newsArray.c_id &&
            r.themeWordId == findOneByIdThemes.c_u_ThemeId
          );
        });
        if (findThemeNews == undefined) {
          this.$api.data.endpoint = "ThemeWordsNews";
          let objectThemes = {
            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
            c_u_Type: 0,
            c_u_Status: 1,
            c_r_ThemeWords: findOneByIdThemes.c_id,
            c_r_News: newsArray.c_id,
          };
          await this.$api.data.create(objectThemes);
        }
      }
      this.selectedThematics = [];
      // upload Image to the server;
      let patt = /media/;
      let previewImage = document.getElementById("output");
      let result = previewImage.src.match(patt);
      if (previewImage.src != "" && result == null) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
          data: this.postImageData,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image";
        var ImageResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.postImageData
        );
      }
      let input = document.getElementById("filesMedia2");
      let files = input.files;

      if (files.length > 0) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
          data: this.mediaPath,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image/VideoAudio";
        var VideoAudioResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.mediaPath
        );
      }
      for (let index = 0; index < this.filteredsNews.length; index++) {
        if (this.filteredsNews[index].c_id == newsArray.c_id) {
          this.filteredsNews[index].c_u_Status = 8;
        }
      }

      if (newsArray.c_id > 0) {
        //process base64 images after other media uploads
        this.$api.data.endpoint = "News/PostSaveProcessBase64";
        var Payload = { NewsID: newsArray.c_id, UserID: this.getLoggedInUserID() };
        try {
          await this.$api.data.update(Payload);
        } catch (err) {}
      }

      this.imagesUpload(newsArray);
      this.isHidden = false;
      if (this.validateNews == true) {
        // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
        //   return o.c_u_Status != 8;
        // });
        const predicate = (start, end) => ({ c_u_Status }) =>
          c_u_Status != start && c_u_Status != end;

        this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
      }
    },
    async imagesUpload(newsArray) {
      let divInputs = $("#imageUpload");
      let formData = new FormData();
      if (divInputs[0].childNodes.length > 0) {
        for (let index = 0; index < divInputs[0].childNodes.length; index++) {
          let files = divInputs[0].childNodes[index].files;
          for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
          }
        }
        this.$api.data.endpoint = "Image/media";
        await this.$api.data.uploadImageById(
          typeof newsArray == "number" ? newsArray : newsArray.c_id,
          formData
        );
      } else {
        //this is used for the base64 images, to be able to set as main image
        formData.append("files", []);
        this.$api.data.endpoint = "Image/media";
        await this.$api.data.uploadImageById(
          typeof newsArray == "number" ? newsArray : newsArray.c_id,
          formData
        );
      }
    },
    uploadFiles(inputId) {
      let input = document.getElementById(inputId);
      let files = input.files;
      let reader = new FileReader();
      let formData = new FormData();

      for (let i = 0; i != files.length; i++) {
        formData.append("files", files[i]);
      }
      this.postImageData = formData;
      reader.onload = function (e) {
        $("#output").attr("src", e.target.result);
      };

      reader.readAsDataURL(input.files[0]);
    },
    uploadFilesMedia(inputId) {
      let InputNumber = inputId.replace("filesMedia","");
      
      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
      document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
      document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";

      let input = document.getElementById(inputId);
      let files = input.files;
      let reader = new FileReader();
      let formData = new FormData();

      for (let i = 0; i != files.length; i++) {
        formData.append("files", files[i]);
      }
      // Create a blob that we can use as an src for our audio element
      const urlObj = URL.createObjectURL(files[0]);
      // Create an audio element
      const audio = document.createElement("audio");
      const video = document.createElement("video");

      audio.id = "audioUploaded";
      video.id = "videoUploaded";

      if (files[0].type.match("audio")) {
        // if (document.getElementById("audioPreview") != null || document.getElementById("videoPreview")) {
        //   document.getElementById("audioPreview").remove();
        //   document.getElementById("videoPreview").remove();
        // }
        // Clean up the URL Object after we are done with it
        audio.addEventListener("load", () => {
          URL.revokeObjectURL(urlObj);
        });
        document.getElementById("fileVideoAudio" + InputNumber).appendChild(audio);

        // Allow us to control the audio
        audio.controls = "true";

        // Set the src and start loading the audio from the file
        audio.src = urlObj;
      }
      if (files[0].type.match("video")) {
        // if (document.getElementById("videoPreview") != null) {
        //   document.getElementById("viewPreview").remove();
        // }
        video.addEventListener("load", () => {
          URL.revokeObjectURL(urlObj);
        });
        video.style.width = "300px";
        video.style.height = "200px";
        // Append the audio element

        document.getElementById("fileVideoAudio" + InputNumber).appendChild(video);

        video.controls = "true";
        video.src = urlObj;
      }

      this.mediaPath = formData;
    },
    openEnLargeImg() {
      // Get the modal
      let modal = document.getElementById("myModal");

      // Get the image and insert it inside the modal
      let img = document.getElementById("output");
      let modalImg = document.getElementById("img01");
      let captionText = document.getElementById("caption");
      modal.style.display = "block";
      modalImg.src = img.src;
      captionText.innerHTML = img.alt;

      // Get the <span> element that closes the modal
      let span = document.getElementsByClassName("close")[0];

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      };
    },
    deleteImg() {
      let img = document.getElementById("output");
      img.src = "";
    },
    async createJournalist(journalist) {
      debugger;
      if (journalist !== undefined) {
        if (journalist != null) {
          if (typeof journalist === 'string') {
            if (journalist.trim().length > 0) {
              this.$api.data.endpoint = this.endpointJournalist;
              let newJournalist = { c_u_Name: journalist };
              await this.$api.data.create(newJournalist);
            }
          }
          else if(typeof journalist === 'object') {
            if (journalist.hasOwnProperty("c_u_name")) {
              if (journalist.c_u_name.trim().length > 0) {
                this.$api.data.endpoint = this.endpointJournalist;
                let newJournalist = { c_u_Name: journalist.c_u_name };
                await this.$api.data.create(newJournalist);
              }
            }
            else if (journalist.hasOwnProperty("name")) {
              if (journalist.name.trim().length > 0) {
                this.$api.data.endpoint = this.endpointJournalist;
                let newJournalist = { c_u_Name: journalist.name };
                await this.$api.data.create(newJournalist);
              }
            }
          }
        }  
      }
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    drag(item) {
      // if (ev.dataTransfer != undefined) {
      //   ev.dataTransfer.setData("text", ev.target.id);
      // } else {
      let checkIfContains = _.find(this.selectedThematics, function (ck) {
        return ck.wordName == item.wordName;
      });
      if (checkIfContains == undefined) {
        this.selectedThematics.push(item);
      }
      // var item = ev.target;
      // var cloneItem = item.cloneNode(true);
      // let checkIfExist = true;
      // if ($("#divDragAndDrop")[0].childNodes.length > 0) {
      //   for (
      //     let index = 0;
      //     index < $("#divDragAndDrop")[0].childNodes.length;
      //     index++
      //   ) {
      //     if (ev.target.id == $("#divDragAndDrop")[0].childNodes[index].id) {
      //       checkIfExist = false;
      //     }
      //   }
      // }
      // if (checkIfExist == true) {
      //   $(cloneItem).appendTo("#divDragAndDrop");
      //   item.style.color = "Green";
      //   for (
      //     let index = 0;
      //     index < $("#divDragAndDrop")[0].childNodes.length;
      //     index++
      //   ) {
      //     $("#divDragAndDrop")[0].childNodes[index].classList.remove("col");
      //     $("#divDragAndDrop")[0].childNodes[index].classList.add("col-sm-4");
      //   }
      // }
      //}
    },
    drop(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("text");
      ev.target.appendChild(document.getElementById(data));
    },
    async deleteThematic(index, id) {
      let deleteThemes = this.selectedThematics[index];

      let findThemeNews =
        deleteThemes.c_id == undefined ? undefined : deleteThemes;
      // this.$api.data.endpoint = "ThemeWords";
      // let findThemeWord = _.find(await this.$api.data.find(), function (f) {
      //   return f.c_u_ThemeId == deleteThemes.id;
      // });
      this.$api.data.endpoint = `ThemeWordsNews`;
      // let findThemeNews = _.find(await this.$api.data.find(), function (r) {
      //   return r.c_r_News == id && r.c_r_ThemeWords == findThemeWord.c_id;
      // });
      if (findThemeNews != undefined) {
        await this.$api.data.destroyById(findThemeNews.c_id);

        let section =
          document.getElementById("sectionThems") != undefined
            ? document.getElementById("sectionThems").childNodes
            : [];
        let findSection = _.find(section, function (o) {
          return o.innerHTML == deleteThemes.wordName;
        });
        if (findSection != undefined) {
          findSection.style.color = "";
          findSection.style.backgroundColor = "";
          findSection.style.fontWeight = "";
        }
      } else {
        let section =
          document.getElementById("sectionThems") != undefined
            ? document.getElementById("sectionThems").childNodes
            : [];
        let findSection = _.find(section, function (o) {
          return o.innerHTML == deleteThemes.wordName;
        });
        if (findSection != undefined) {
          findSection.style.color = "";
          findSection.style.backgroundColor = "";
          findSection.style.fontWeight = "";
        }
      }
      let section =
        document.getElementById("sectionThems") != undefined
          ? document.getElementById("sectionThems").childNodes
          : [];
      let findSection = _.find(section, function (o) {
        return o.innerHTML == deleteThemes.wordName;
      });
      if (findSection.style.color == "") {
        this.isThematicDelete = true;
        this.isThematicDeleteId = deleteThemes.id;
        this.selectedThematics.splice(index, 1);
        this.$forceUpdate();
      }
    },
    async deleteEditNew(newsArray) {
      if (newsArray.c_u_Status == 8 || newsArray.c_u_Status == 10) {
        this.$bvToast.toast("Não é possível eliminar uma notícia publicada", {
          autoHideDelay: 4000,
          variant: "warning",
        });
      }
      else {
        this.$api.data.endpoint = this.endpointNews;
        newsArray.c_u_NewsEditByUser = this.getLoggedInUserID();
        let d = new Date();
        let mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let yy = d.getFullYear();
        newsArray.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
        newsArray.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

        newsArray.c_u_Status = -1;
        try {
          await this.$api.data.updatedById(newsArray.c_id, newsArray);
        } catch (err) {}
        this.newsArray = [];
        // remove selected source in the first section
        let sourceName = document.getElementsByClassName("section1Name");
        for (let i = 0; i < sourceName.length; i++) {
          if (sourceName[i].style.color != "") {
            sourceName[i].style.color = null;
            sourceName[i].style.fontWeight = null;
          }
        }

        if (newsArray.c_id > 0) {
          //process base64 images after other media uploads
          this.$api.data.endpoint = "News/PostSaveProcessBase64";
          var Payload = { NewsID: newsArray.c_id, UserID: this.getLoggedInUserID() };
          try {
            await this.$api.data.update(Payload);
          } catch (err) {}
        }

        this.isHidden = false;
        if (this.isFilteredData == true) {
          this.filterData();
        }
        else {
          this.clickedEvent(
            this.clickedEventSourceId,
            this.clickedEventSourceName
          );
        }
      }
    },
    async copyEditedNew(newsArray) {
      newsArray.c_u_Status = 7;
      newsArray.c_u_Summary =
        newsArray.c_u_Summary != ""
          ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "")
          : newsArray.c_u_Summary;
      //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

      //news create date and time
      if(this._newsDate.trim().length > 0 && this._newsTime.trim().length > 0) {
        newsArray.c_u_NewsDateCreate = this._newsDate+"T"+this._newsTime+":00.000";
      }

      // check if we have the journalist in the list
      if (newsArray.c_r_Journalist != null) {
        if (typeof newsArray.c_r_Journalist.name == "string") {
          this.$api.data.endpoint = this.endpointJournalist;
          let checkIdJournalist = _.find(
            await this.$api.data.find(),
            function (journalist) {
              return journalist.c_u_Name == newsArray.c_r_Journalist.name;
            }
          );
          newsArray.c_r_Journalist = checkIdJournalist.c_id;
        } else {
          newsArray.c_r_Journalist = newsArray.c_r_Journalist;
        }
      }
      this.$api.data.endpoint = this.endpointNews;
      try {
        await this.$api.data.updatedById(newsArray.c_id, newsArray);
      } catch (err) {}

      // create the thematic
      for (let index = 0; index < this.selectedThematics.length; index++) {
        let objectThemesWord = {
          c_u_Words: this.selectedThematics[index].wordName,
          c_u_ThemeId: this.selectedThematics[index].id,
        };
        this.$api.data.endpoint = "ThemeWords";
        let findOneByIdThemes = _.find(
          await this.$api.data.find(),
          function (o) {
            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
          }
        );
        this.$api.data.endpoint = `ThemeWordsNews/Thematics/${newsArray.c_id}`;
        let findThemeNews = _.find(await this.$api.data.find(), function (r) {
          return (
            r.themeNews == newsArray.c_id &&
            r.themeWordId == findOneByIdThemes.c_u_ThemeId
          );
        });
        if (findThemeNews == undefined) {
          this.$api.data.endpoint = "ThemeWordsNews";
          let objectThemes = {
            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
            c_u_Type: 0,
            c_u_Status: 1,
            c_r_ThemeWords: findOneByIdThemes.c_id,
            c_r_News: newsArray.c_id,
          };
          await this.$api.data.create(objectThemes);
        }
      }
      this.selectedThematics = [];
      // upload Image to the server;
      let patt = /media/;
      let previewImage = document.getElementById("output");
      let result = previewImage.src.match(patt);
      if (previewImage.src != "" && result == null) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
          data: this.postImageData,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image";
        var ImageResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.postImageData
        );
      }
      let input = document.getElementById("filesMedia2");
      let files = input.files;

      if (files.length > 0) {
        //old way - CORS errors
        /*$.ajax({
          url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
          data: this.mediaPath,
          processData: false,
          contentType: false,
          type: "PATCH",
        });*/
        //new way - to avoid CORS errors
        this.$api.data.endpoint = "Image/VideoAudio";
        var VideoAudioResult = await this.$api.data.uploadImageById(
          newsArray.c_id,
          this.mediaPath
        );
      }

      this.isHidden = false;
      this.newsArray = [];
      // remove selected source in the first section
      let sourceName = document.getElementsByClassName("section1Name");
      for (let i = 0; i < sourceName.length; i++) {
        if (sourceName[i].style.color != "") {
          sourceName[i].style.color = null;
          sourceName[i].style.fontWeight = null;
        }
      }

      if (newsArray.c_id > 0) {
        //process base64 images after other media uploads
        this.$api.data.endpoint = "News/PostSaveProcessBase64";
        var Payload = { NewsID: newsArray.c_id, UserID: this.getLoggedInUserID() };
        try {
          await this.$api.data.update(Payload);
        } catch (err) {}
      }

      this.imagesUpload(newsArray);
      this.isHidden = false;
      if (this.isFilteredData == true) {
        this.filterData();
      }
      else {
        this.clickedEvent(
          this.clickedEventSourceId,
          this.clickedEventSourceName
        );
      }
    },
    selectAllNews() {
      //debugger;
      this.selectedNews = [];
      if (this.validateNews) {
          for (let index = 0; index < this.filteredsNews.length; index++) {
          if (this.selectedNews[index] == undefined) {
            this.selectedNews.push(this.filteredsNews[index].c_id);
          }
        }
      }
      else {
        for (let index = 0; index < this.optionsNews.length; index++) {
          if (this.selectedNews[index] == undefined) {
            this.selectedNews.push(this.optionsNews[index][0].item);
          }
        }
      }
    },
    async deleteAllNews() {
      //old delete method
      /*this.$api.data.endpoint = this.endpointNews;
      for (let index = 0; index < this.selectedNews.length; index++) {
        let findOne = await this.$api.data.findOneById(
          this.selectedNews[index]
        );
        findOne.c_u_Status = -1;
        try { await this.$api.data.updatedById(findOne.c_id, findOne); }
        catch (err) { }
        try { document.getElementById("section2NewId" + findOne.c_id).style.display = "none"; }
        catch (err) { }
      }*/

      //console.log("this.selectedNews", this.selectedNews);
      //console.log("itcNewsItem", $("div[name='dNewsItem'] input[name='itcNewsItem']:checked"));

      //new delete method
      if (this.selectedNews.length == 0) {
        this.$bvToast.toast("Selecione notícias para eliminar", {
          autoHideDelay: 4000,
          variant: "danger",
        });
      } else {
        this.$api.data.endpoint = "News/SetStatusDeleted";
        var Payload = { NewsIDs: this.selectedNews, UserID: this.getLoggedInUserID() };
        try {
          await this.$api.data.update(Payload);
        } catch (err) {}

        // remove selected source in the first section
        let sourceName = document.getElementsByClassName("section1Name");
        for (let i = 0; i < sourceName.length; i++) {
          if (sourceName[i].style.color != "") {
            sourceName[i].style.color = null;
            sourceName[i].style.fontWeight = null;
          }
        }
        this.isHidden = false;
        this.selectedNews = [];

        if (this.isFilteredData == true) {
          this.filterData();
        }
        else {
          this.clickedEvent(
            this.clickedEventSourceId,
            this.clickedEventSourceName
          );
        }
      }
    },
    async publishAllNews() {
      //old publish method
      /*this.$api.data.endpoint = this.endpointNews;
      for (let index = 0; index < this.selectedNews.length; index++) {
        let findOne = await this.$api.data.findOneById(
          this.selectedNews[index]
        );
        findOne.c_u_Status = 8;
        findOne.c_u_NewsPublishedByUser = this.getLoggedInUserID();
        try {
          await this.$api.data.updatedById(findOne.c_id, findOne);
        } catch (err) {}
      }*/

      //new publish method
      if (this.selectedNews.length == 0) {
        this.$bvToast.toast("Selecione notícias para publicar", {
          autoHideDelay: 4000,
          variant: "danger",
        });
      } else {
        this.$api.data.endpoint = "News/SetStatusPublished";
        var Payload = { NewsIDs: this.selectedNews, UserID: this.getLoggedInUserID() };
        try {
          await this.$api.data.update(Payload);
        } catch (err) {}

        // remove selected source in the first section
        let sourceName = document.getElementsByClassName("section1Name");
        for (let i = 0; i < sourceName.length; i++) {
          if (sourceName[i].style.color != "") {
            sourceName[i].style.color = null;
            sourceName[i].style.fontWeight = null;
          }
        }
        this.isHidden = false;
        this.filteredsNews = [];
        this.selectedNews = [];
        //this.showData();

        if (this.isFilteredData == true) {
          this.filterData();
        }
        else {
          this.clickedEvent(
            this.clickedEventSourceId,
            this.clickedEventSourceName
          );
        }
      }
    },
    clearFilters() {
      this.isFilteredData = false;
      this.noNewsFromCheckbox = false;
      this.selectedFilterSource = [];
      this.selectedFilterStatus = "";
      this.selectedFilterUsers = [];
      this.selectedFilterType = [];
      this.selectedFilterTheme = [];
      this.filteredText = "";
      this.filtersDates = {
        startDate: "",
        endDate: "",
      };
      // remove selected source in the first section
      let sourceName = document.getElementsByClassName("section1Name");
      for (let i = 0; i < sourceName.length; i++) {
        if (sourceName[i].style.color != "") {
          sourceName[i].style.color = null;
          sourceName[i].style.fontWeight = null;
        }
      }
      this.isHidden = false;
      this.filteredsNews = [];
    },
    async filterData() {
      /*
      filterData() -> pesquisar notícias
      clickedScrolll() -> ver mais notícias
      clickedEvent() -> obter notícias carregando na fonte
      selectAllNews() -> função que seleciona todas as notícias listadas
      
      filteredsNews -> lista filtrada pela webapi (ao carregar no botão pesquisar)
      dataFromFilter -> lista filtrada pela webapi (ao carregar no botão pesquisar)
      neededArrayOfNews -> lista de notícias de uma fonte (ao carregar na fonte à esquerda)
      optionsNews -> lista que guarda as opções listadas
      selectedNews -> lista de notícias selecionadas
          
      validateNews -> booleano que indica se as publicadas estão ocultas
      noNewsFromCheckbox -> boolenano, após filtrar para esconder as publicadas, indica se existem resultados
      */
      
      //debugger;
      if (!this.isNotCreatedNew) {
        this.cancelCreationOfNew();
      }

      this.isFilteredData = true;
      this.isNotCreatedNew = true;
      // remove selected source in the first section
      let sourceName = document.getElementsByClassName("section1Name");
      for (let i = 0; i < sourceName.length; i++) {
        if (sourceName[i].style.color != "") {
          sourceName[i].style.color = null;
          sourceName[i].style.fontWeight = null;
        }
      }
      this.isHidden = false;

      // if (
      //   this.filtersDates.startDate != "" &&
      //   this.filtersDates.endDate == ""
      // ) {
      //   let todaysDate = new Date();
      //   todaysDate =
      //     todaysDate.getFullYear() +
      //     "-" +
      //     (todaysDate.getMonth() + 1 < 10
      //       ? "0" + (todaysDate.getMonth() + 1)
      //       : todaysDate.getMonth() + 1) +
      //     "-" +
      //     (todaysDate.getDate() < 10
      //       ? "0" + todaysDate.getDate()
      //       : todaysDate.getDate());
      //   this.filtersDates.endDate = todaysDate;
      // }
      // if (this.filteredData.length == 0) {
      //   if (this.selectedFilterSource.length > 0) {
      //     for (
      //       let index = 0;
      //       index < this.selectedFilterSource.length;
      //       index++
      //     ) {
      //       if (this.filteredNewsBySource[index] == undefined) {
      //         this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredNews}/${this.selectedFilterSource[index]}`;
      //         this.filteredNewsBySource.push(
      //           _.filter(await this.$api.data.find(), src => {
      //             return src.c_r_Source == this.selectedFilterSource[index];
      //           })
      //         );
      //       }
      //     }
      //   }
      //   for (let index = 0; index < this.filteredNewsBySource.length; index++) {
      //     for (let i = 0; i < this.filteredNewsBySource[index].length; i++) {
      //       this.eachNewBySource.push(this.filteredNewsBySource[index][i]);
      //     }
      //   }
      //   this.filteredData = _.xor(this.eachNewBySource);
      // }
      // // filter the dates
      // if (this.filteredData.length > 0) {
      //   if (
      //     this.filtersDates.startDate != "" &&
      //     this.filtersDates.endDate != ""
      //   ) {
      //     this.filteredData = _.filter(this.filteredData, strDate => {
      //       return (
      //         Date.parse(strDate.c_u_ProcessedDate.split("T")[0]) >=
      //           Date.parse(this.filtersDates.startDate) &&
      //         Date.parse(strDate.c_u_ProcessedDate.split("T")[0]) <=
      //           Date.parse(this.filtersDates.endDate)
      //       );
      //     });
      //   }
      // } else {
      //   if (
      //     this.filtersDates.startDate != "" &&
      //     this.filtersDates.endDate != ""
      //   ) {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByDate}/${this.filtersDates.startDate}/${this.filtersDates.endDate}`;
      //     this.filteredData = await this.$api.data.find();
      //   }
      // }

      // //filtered the status
      // if (this.filteredData.length > 0) {
      //   if (typeof this.selectedFilterStatus == "number") {
      //     this.filteredData = _.filter(this.filteredData, status => {
      //       return status.c_u_Status == this.selectedFilterStatus;
      //     });
      //   }
      // } else {
      //   if (typeof this.selectedFilterStatus == "number") {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByStatus}/${this.selectedFilterStatus}`;
      //     this.filteredData = await this.$api.data.find();
      //   }
      // }
      // //filtered the type
      // if (this.filteredData.length > 0) {
      //   if (typeof this.selectedFilterType == "number") {
      //     this.filteredData = _.filter(this.filteredData, status => {
      //       return status.c_u_Type == this.selectedFilterType;
      //     });
      //   }
      // } else {
      //   if (typeof this.selectedFilterType == "number") {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByType}/${this.selectedFilterType}`;
      //     this.filteredData = await this.$api.data.find();
      //   }
      // }
      // //filtered the type
      // if (this.filteredData.length > 0) {
      //   if (typeof this.selectedFilterTheme == "number") {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByTheme}/${this.selectedFilterTheme}`;
      //     let theme = await this.$api.data.find();
      //     let newFilteredData = [];
      //     for (let index = 0; index < this.filteredData.length; index++) {
      //       for (let i = 0; i < theme.length; i++) {
      //         if (theme[i].c_id == this.filteredData[index].c_id) {
      //           newFilteredData.push(this.filteredData[index]);
      //         }
      //       }
      //     }
      //     this.filteredData = newFilteredData;
      //     // this.filteredData = _.filter(this.filteredData, status => {
      //     //   return status.c_u_Type == this.selectedFilterTheme;
      //     // });
      //   }
      // } else {
      //   if (typeof this.selectedFilterTheme == "number") {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByTheme}/${this.selectedFilterTheme}`;
      //     this.filteredData = await this.$api.data.find();
      //   }
      // }

      // //filtered the User
      // if (this.filteredData.length > 0) {
      //   if (typeof this.selectedFilterUsers == "number") {
      //     this.filteredData = _.filter(this.filteredData, status => {
      //       return (
      //         status.c_u_NewsEditByUser == this.selectedFilterUsers ||
      //         status.c_u_NewsPublishedByUser == this.selectedFilterUsers
      //       );
      //     });
      //   }
      // } else {
      //   if (typeof this.selectedFilterUsers == "number") {
      //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByUser}/${this.selectedFilterUsers}`;
      //     this.filteredData = await this.$api.data.find();
      //   }
      // }

      // //filtered the Text
      // if (this.filteredData.length > 0) {
      //   if (this.filteredText != "") {
      //     this.filteredData = _.filter(this.filteredData, text => {
      //       return text.c_u_Content.match(this.filteredText);
      //     });
      //   }
      // } else {
      //   if (this.filteredText != "") {
      //     this.$api.data.endpoint = this.endpointNews;
      //     this.filteredData = _.filter(await this.$api.data.find(), text => {
      //       return text.c_u_Content.match(this.filteredText);
      //     });
      //   }
      // }
      // this.filteredsNews = this.filteredData.sort(
      //   (a, b) =>
      //     Date.parse(b.c_u_ProcessedDate) - Date.parse(a.c_u_ProcessedDate)
      // );
      // for (let index = 0; index < this.filteredsNews.length; index++) {
      //   this.optionsNews[index] = [];
      //   this.optionsNews[index].push({
      //     item: this.filteredsNews[index].c_id,
      //     name: ""
      //   });
      // }

      if (
        this.selectedFilterSource.length == 0 &&
        this.filtersDates.startDate == "" &&
        this.filtersDates.endDate == "" &&
        typeof this.selectedFilterStatus != "number" &&
        typeof this.selectedFilterType != "number" &&
        typeof this.selectedFilterTheme != "number" &&
        typeof this.selectedFilterUsers != "number" &&
        this.filteredText == ""
      ) {
        this.$bvToast.toast("Necessario preencher campos!", {
          autoHideDelay: 4000,
          variant: "danger",
        });
      } else {
        if (
          this.filtersDates.startDate != "" &&
          this.filtersDates.endDate == ""
        ) {
          let todaysDate = new Date();
          todaysDate =
            todaysDate.getFullYear() +
            "-" +
            (todaysDate.getMonth() + 1 < 10
              ? "0" + (todaysDate.getMonth() + 1)
              : todaysDate.getMonth() + 1) +
            "-" +
            (todaysDate.getDate() < 10
              ? "0" + todaysDate.getDate()
              : todaysDate.getDate());
          this.filtersDates.endDate = todaysDate;
        }
        let urlEncoderSource =
          this.selectedFilterSource.length != 0
            ? encodeURIComponent(this.selectedFilterSource.toString())
            : 0;
        let startDateFilter =
          this.filtersDates.startDate == "" ? 0 : this.filtersDates.startDate;
        let endDateFilter =
          this.filtersDates.endDate == "" ? 0 : this.filtersDates.endDate;
        let statusFilter =
          typeof this.selectedFilterStatus != "number"
            ? 0
            : this.selectedFilterStatus;
        let typeFilter =
          typeof this.selectedFilterType != "number"
            ? 20
            : this.selectedFilterType;
        let themeFilter =
          typeof this.selectedFilterTheme != "number"
            ? 0
            : this.selectedFilterTheme;
        let userFilter =
          typeof this.selectedFilterUsers != "number"
            ? 0
            : this.selectedFilterUsers;
        let textFilter = this.filteredText == "" ? 0 : this.filteredText;

        //Call the endpoint of filter
        this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredSection}/${urlEncoderSource}/${typeFilter}/${themeFilter}/${startDateFilter}/${endDateFilter}/${statusFilter}/${userFilter}/${textFilter}/0`;
        this.filteredData = await this.$api.data.find();
        this.filteredsNews = this.filteredData;
        this.dataFromFilter = this.filteredsNews;
        //debugger;
        this.optionsNews = [[]];
        for (let index = 0; index < this.filteredsNews.length; index++) {
          this.optionsNews[index] = [];
          this.optionsNews[index].push({
            item: this.filteredsNews[index].c_id,
            name: "",
          });
        }
      }

      if (this.validateNews == true) {
        // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
        //   return o.c_u_Status != 8;
        // });
        const predicate = (start, end) => ({ c_u_Status }) =>
          c_u_Status != start && c_u_Status != end;

        this.filteredsNews = this.filteredsNews.filter(predicate(8, 10));
      } else {
        this.filteredsNews = this.dataFromFilter;
      }

      this.filteredData = [];
      this.filteredNewsBySource = [];
      this.eachNewBySource = [];
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = "350px";
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy();
    },
  },
  async mounted() {
    this.showData();
    this.onResize();
    this.filtersHeight = document.getElementById(
      "filtersHeightSize"
    ).clientHeight;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.newsEdition {
  overflow: hidden;
  height: 100vh;
  overflow: hidden;
}

.newsEditionFirst {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
}

.sectionsFilters {
  margin-top: 10px;
  margin-left: 2px;
}

.filters {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  margin-right: 10px;
  margin-top: 15px;
  height: 36px;
  bottom: 0px;
}

.filtersTitle {
  float: left;
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.btnFilters {
  margin-top: 15px;
}
.sections {
  margin-top: 10px;
  height: 100%;
}
.section1 {
  margin-top: 10px;
  background-color: rgb(242, 242, 242);
  height: 100%;
}
.contentOfSection1 {
  overflow-x: hidden;
  overflow-y: scroll;
  /* height: 60%; */
  height: 63%;
  /* scrollbar-width: none; */
}
/* .contentOfSection1::-webkit-scrollbar {
  display: none;
} */

.section1Name {
  font-size: 11px;
  text-align: left;
  cursor: pointer;
}
.section1Name span {
  color: rgb(66, 139, 172);
  font-weight: bold;
}

.section1 button {
  text-align: center;
  margin: 10px;
  font-size: 13px;
}
.section1Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
}

.section2Div {
  display: block;
  max-height: 100%;
  height: 100%;
}

.section2 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  overflow-x: hidden;
  height: 67%;
  display: block;
}

.section2Footer {
  margin-top: 10px;
  background-color: rgb(242, 242, 242);
  padding: 10px;
}

.section2News {
  border: 2px solid rgb(242, 242, 242);
  background-color: white;
  margin-top: 5px;
}

.section2News:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.section2Btn {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  font-size: 16px;
}

.createDiv {
  text-align: right;
}

.createBtn {
  border-radius: 20px;
  background-color: rgb(231, 242, 245);
  color: rgb(66, 139, 172);
  padding: 0.275rem 0.55rem;
}

.section3Div {
  display: block;
  max-height: 100%;
  height: 100%;
}

.section3 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  height: 67%;
  overflow-x: hidden;
  display: block;
}

.newsCreationContainer {
  display: none;
  height: 100%;
}
.section5Div {
  display: block;
  max-height: 100%;
  height: 100%;
}

.section5 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  height: 67%;
  overflow-x: hidden;
  display: block;
}
.section4Div {
  display: block;
  /* max-height: 100%;
  height: 100%; */
  height: 95%;
}

.section6Div {
  display: block;
  /* max-height: 100%;
  height: 100%; */
  height: 95%;
}
.not-found-section3 {
  margin: 10px;
  display: flex;
  align-items: center;
}

.not-found {
  display: flex;
  justify-content: center;
}
.isEditedNewUser {
  font-weight: bold;
}
.section2Footer button {
  border-radius: 25px;
  border: none;
  width: 100%;
}
.hidden {
  display: none;
}

.section3Title {
  margin-top: 5px;
  text-align: left;
  font-weight: bold;
  color: rgb(66, 139, 172);
}
.section3Image {
  background: white;
  /* height: 100%; */
  border: 1px solid #ced4da;
}

.section3ImageMargin {
  margin-top: 10px;
  margin-bottom: 10px;
}

.imageBtnStyle {
  margin-top: 2px;
  margin-bottom: 10px;
  border: 1px solid #ced4da;
  text-align: center;
}

.uploadBtn {
  background: rgb(66, 139, 172);
  border-radius: 100px;
  text-align: center;
  margin-top: 60px;
  width: 50px;
  height: 50px;
}

.uploadBtn .label {
  line-height: 50px;
  pointer-events: none;
  color: white;
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  width: 50px;
  height: 50px;
}

#files {
  opacity: 0;
  cursor: pointer;
  font-size: 50px;
  width: 50px;
  height: 50px;
}

#filesMedia1,#filesMedia2 {
  cursor: pointer;
}

#divDragAndDrop {
  min-height: 100px;
  height: 100%;
  cursor: pointer;
}

.section4Themes {
  display: block;
  overflow-x: hidden;
  overflow-y: scroll;
  /* height: 100%; */
  height: 70%;
  padding: 0px;
  word-break: break-word;
}

.section6Div {
  display: block;
  /* max-height: 100%;
  height: 100%; */
  height: 95%;
}

.section6Themes {
  display: block;
  overflow-x: hidden;
  overflow-y: scroll;
  /* height: 100%; */
  height: 70%;
  padding: 0px;
  word-break: break-word;
}

/* .section4Themes::-webkit-scrollbar {
  display: none;
} */

.scrollForBody {
  overflow-x: hidden;
  overflow-y: scroll;
}

.scrollForBody::-webkit-scrollbar {
  display: none;
}

#AVEdropDown {
  background-color: white;
}

.thematicStyle {
  border-bottom: 1px solid #ced4da;
  padding: 0px;
  /* border-radius: 25px; */
  text-align: left;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
  color: rgb(66, 139, 172);
}

.thematicStyle[kb='1'] {
  border: 2px solid #000 !important;
}

.thematic {
  border: 1px solid #ced4da;
  border-radius: 25px;
  text-align: left;
  font-size: 12px;
  margin: 5px;
  padding: 5px;
  color: rgb(66, 139, 172);
  background-color: white;
  height: 100%;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Caption of Modal Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.NewsExtractedFrom {
  margin-top: 10px;
  word-wrap: break-word;
  text-align: left;
}

.section3 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  height: 67%;
  display: block;
}
.uploadBtn[data-v-358d602a] {
  background: rgb(66, 139, 172);
  border-radius: 100px;
  text-align: center;
  margin-top: 60px;
  margin-left: 60px;
  width: 50px;
  height: 50px;
  /* padding: 20px; */
}

/* On screens that are 600px wide or less, the background color is olive */
/* @media screen and (max-width: 1300) {
  .section2[data-v-358d602a] {
    background-color: rgb(242, 242, 242);
    overflow-y: scroll;
    overflow-x: hidden;
    height: 50%;
    display: block;
}
} */
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsEdition.vue